/*
 * Kukoon search.
 *
 * This is the prototype, running on the storefront: the same engine, the same
 * markup (snippets/kukoon-search-app.liquid), the same stylesheet
 * (assets/kukoon-search.css). Nothing has been reinterpreted, so what ships is
 * what was signed off.
 *
 * Generated by build_theme_identical.py from search_template.tpl. Edit the
 * prototype and regenerate - changes made here are overwritten.
 *
 * The only difference from the artifact: the catalogue is fetched as a theme
 * asset instead of being baked into the page, so it can be rebuilt nightly
 * without touching the theme.
 */
(function () {
  var cfg = window.KukoonSearch || {};
  if (!cfg.indexUrl) {
    if (window.console) console.warn('[search] no index URL - see theme.liquid');
    return;
  }

  // The settings the shop can change without a deploy - popular searches,
  // synonyms, muted terms - written by the dashboard on the internal server.
  // Fetched alongside the index and allowed to fail: if it is missing, stale
  // or the server is down, the search runs on what it shipped with. That is
  // why it is a separate small file and not part of the index.
  var KUKOON_SETTINGS = null;

  function settings() {
    if (!cfg.settingsUrl) return Promise.resolve(null);
    // 2.5s at most, like the live index. The search waits for this, and where
    // our server can't be reached at all (Jack on a Dutch VPN, 5 Oct 2026) the
    // request hung with no answer and the search never started.
    var ctl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = ctl ? setTimeout(function () { ctl.abort(); }, 2500) : null;
    return fetch(cfg.settingsUrl, { credentials: 'omit', signal: ctl ? ctl.signal : undefined })
      .then(function (r) { if (timer) clearTimeout(timer); return r.ok ? r.json() : null; })
      .then(function (doc) { return doc && doc.settings ? doc.settings : null; })
      .catch(function () { return null; });
  }

  // The index: this morning's, from our own server, if it answers quickly;
  // otherwise the copy bundled with the theme. The live one is rebuilt every
  // morning on KR-RDS-001, so new products and tags are searchable the next
  // day without a theme upload. The bundled one is only as fresh as the last
  // upload - but it is on Shopify's CDN and always there, so an outage on our
  // side costs a day of freshness, never the search itself.
  //
  // Either copy is refused if it does not look like an index: a response that
  // parses but holds nothing would otherwise open a shop with no products.
  function getIndex(url, ms) {
    var ctl = (typeof AbortController !== 'undefined' && ms) ? new AbortController() : null;
    var timer = ctl ? setTimeout(function () { ctl.abort(); }, ms) : null;
    // 'same-origin', to match the preload's crossorigin attribute. With 'omit'
    // the browser treats them as different requests and downloads it twice.
    // Both hosts are cross-origin, so no cookies are sent either way.
    return fetch(url, { credentials: 'same-origin', signal: ctl ? ctl.signal : undefined })
      .then(function (r) {
        if (timer) clearTimeout(timer);
        if (!r.ok) throw new Error(url + ' responded ' + r.status);
        return r.json();
      })
      .then(function (j) {
        if (!Array.isArray(j) || j.length < 100) throw new Error(url + ' does not look like an index');
        return j;
      });
  }

  function index() {
    // shared with Complete the set and Customer favourites (theme.liquid)
    if (window.KukoonIndex) return window.KukoonIndex();
    if (!cfg.liveIndexUrl) return getIndex(cfg.indexUrl);
    return getIndex(cfg.liveIndexUrl, 2500).catch(function (e) {
      if (window.console) console.warn('[search] live index unavailable, using the bundled copy:', e.message);
      return getIndex(cfg.indexUrl);
    });
  }

  /* When to fetch the index. It is ~150KB gzipped and used to be fetched the
     moment any page loaded, competing with that page's own images and CSS
     for a search most visitors never open. Now: straight away on /search;
     elsewhere the first touch of a search box, or once the page has finished
     loading and the browser is idle - whichever comes first. By the time a
     shopper types, it is almost always already here. */
  var booted = false;
  function boot() {
    if (booted) return;
    booted = true;
    Promise.all([
      index(),
      settings(),
    ])
      .then(function (both) {
        KUKOON_SETTINGS = both[1];
        start(both[0]);
        // tells the search page's fallback that it is not needed
        window.__kukSearchStarted = true;
        // Someone who clicked into the box, or even typed, before the index
        // arrived: replay that now, so the panel opens on what they typed
        // rather than waiting for another keystroke.
        var q = document.getElementById('q');
        if (q && document.activeElement === q) {
          q.dispatchEvent(new FocusEvent('focus'));
          q.dispatchEvent(new FocusEvent('focusin', { bubbles: true }));
          if (q.value) q.dispatchEvent(new Event('input', { bubbles: true }));
        }
      })
      .catch(function (e) {
        // a shop that cannot search is worse than one that searches slowly: say
        // so in the console and leave the page alone
        if (window.console) console.error('[search] index failed to load:', e);
        // on /search, show Shopify's own results instead of an empty page
        if (window.__kukSearchFallback) window.__kukSearchFallback();
      });
  }
  var SEARCHY = '#q, [data-kuk-search-open], [data-kuk-search-slot]';
  function early(e) {
    if (e.target && e.target.closest && e.target.closest(SEARCHY)) boot();
  }
  /* 12 Oct 2026 (app audit): no longer fetched when the page goes idle. That
     still downloaded ~500KB on every page for the 1 visitor in 10 who
     searches. Now only when search is reached for - a tap, focus, or a mouse
     over the box - plus /search itself, and a "back" to a page whose search
     panel the shopper had open, which the panel restores from this index. */
  function searchedRecently() {
    try {
      var c = JSON.parse(sessionStorage.getItem('kk.searchctx') || 'null');
      return !!(c && c.term && Date.now() - (c.at || 0) < 30 * 60 * 1000);
    } catch (e) { return false; }
  }
  var nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
  if (cfg.isSearchPage || (nav.type === 'back_forward' && searchedRecently())) {
    boot();
  } else {
    document.addEventListener('focusin', early, true);
    document.addEventListener('pointerdown', early, true);
    document.addEventListener('mouseover', early, true);
    window.addEventListener('pageshow', function (e) { if (e.persisted && searchedRecently()) boot(); });
  }

  function start(CATALOG) {
    /* Sizes and rugs hidden in this shopper's market (31 Oct 2026). Marc's
       custom.hide_on_markets metafield hides them on the product page and in
       collections (snippets/market-hidden-variants); the nightly index carries
       the same list - xm: hidden markets per size, excludedMarkets: hidden in
       every size - so search leaves them out too. Copies, not edits: the index
       is shared with Complete the set and Customer favourites. */
    var MKT = String(cfg.market || '').toLowerCase().trim();
    if (MKT) {
      CATALOG = CATALOG.filter(function (p) {
        return !(p.excludedMarkets || []).some(function (m) { return String(m).toLowerCase() === MKT; });
      }).map(function (p) {
        if (!p.xm) return p;
        var gone = function (s) { return (p.xm[s] || []).indexOf(MKT) !== -1; };
        if (!(p.sz || []).some(gone)) return p;
        var q = Object.assign({}, p);
        q.sz = p.sz.filter(function (s) { return !gone(s); });
        return q;
      });
    }



/* ---------- index ---------- */
const COLOUR_WORDS = new Set(["beige","cream","ivory","white","natural","brown","taupe","grey","gray","silver","charcoal","black","blue","navy","teal","green","sage","olive","red","wine","burgundy","pink","blush","orange","terracotta","rust","ochre","yellow","gold","purple","multicolour","multi","plum","neutral"]);
const STOP = new Set(["the","and","for","with","a","an","of","in","to"]);
/* Words that say nothing about the rug (12 Oct 2026). Every word has to match,
   so one of these killed a whole search: "kukoon round rug" found nothing
   because "kukoon" is on two products, "red colour rug" because "colour" is
   on five. 80-odd searches a fortnight. Dropped from the query only - and
   only when something else is left, so "kukoon" alone still asks a question. */
const FILLER = new Set(["kukoon","kukoons","colour","colours","color","colors","coloured","colored",
  "size","sizes","sized","by","cm","mm","area","suitable","please","my","any","some","very","style"]);
const norm = s => (s||"").toLowerCase().replace(/[^a-z0-9]+/g," ").trim();
function stem(w){
  if (w.length > 4 && w.endsWith("ies")) return w.slice(0, -3) + "y";
  if (w.length > 4 && /(ses|xes|zes|ches|shes)$/.test(w)) return w.slice(0, -2);
  if (w.length > 3 && w.endsWith("s") && !w.endsWith("ss")) return w.slice(0, -1);
  return w;
}
/* Collapse a typed dimension to the same token the index stores, BEFORE the
   punctuation stripper turns "120 x 170cm" into three separate words. */
/* Metres before centimetres: "3m x 2m" is a size, and it returned nothing
   because the catalogue is in cm. Nine searches a quarter, and each one is a
   shopper who has measured their room. 2.5m works too. */
const sizeQuery = s => (s || "").toLowerCase()
  .replace(/(\d(?:\.\d)?)\s*m\s*[x*×]\s*(\d(?:\.\d)?)\s*m(?![a-z])/g,
           (_, a, b) => " " + snapSize(Math.round(a * 100), Math.round(b * 100)) + " ")
  /* Feet, the way people who measured with a tape say it: "5x8ft", "5ft x 8ft",
     "5' x 8'". Converted to cm and left as it is: if we do not sell that exact
     size, search() ranks by the nearest sizes rather than snapping to one. */
  .replace(/(\d{1,2}(?:\.\d)?)\s*(?:ft|feet|foot|')?\s*[x*×]\s*(\d{1,2}(?:\.\d)?)\s*(?:ft|feet|foot|')(?![a-z])/g,
           (_, a, b) => " " + Math.round(a * 30.48) + "x" + Math.round(b * 30.48) + " ")
  .replace(/(\d{2,3})\s*(?:cm)?\s*[x*×]\s*(\d{2,3})\s*(?:cm)?/g, " $1x$2 ");

/* A room measured in metres is never a size we sell. "3m x 2m" converts to
   300x200, which is not a Kukoon size - the nearest are 200x290 and 240x330 -
   so the honest answer is the closest size we do stock rather than nothing.
   Lazily built, because the size vocabulary does not exist yet at this point. */
let SIZE_PAIRS = null;
function snapSize(w, h){
  if (!SIZE_PAIRS){
    SIZE_PAIRS = [];
    for (const v of (typeof VOCAB_ARR !== "undefined" ? VOCAB_ARR : [])){
      const m = /^(\d{2,3})x(\d{2,3})$/.exec(v);
      if (m) SIZE_PAIRS.push([+m[1], +m[2], v]);
    }
  }
  let best = null, bd = Infinity;
  for (const [a, b, v] of SIZE_PAIRS){
    const d = Math.abs(a - w) / w + Math.abs(b - h) / h;
    if (d < bd){ bd = d; best = v; }
  }
  return bd <= 0.5 && best ? best : w + "x" + h;
}
const tok = s => norm(sizeQuery(s)).split(" ")
  .filter(w => w && !STOP.has(w));
const toks = s => tok(s).map(stem);

/* Dimensions, reduced to one comparable token.

   "120cm x 170cm" -> 120x170, and so does "120 x 170", "120x170cm", "120*170".
   95 failed searches in the last 90 days were people typing a size, because
   sizes were held as filters and never indexed. Both orientations are stored,
   since a customer measuring a room does not know which way round we list it. */
function sizeTokens(sz){
  const out = new Set();
  for (const s of sz || []){
    const m = String(s).toLowerCase().match(/(\d{2,3})\s*(?:cm)?\s*[x*×]\s*(\d{2,3})/);
    if (!m) continue;
    out.add(m[1] + "x" + m[2]);
    out.add(m[2] + "x" + m[1]);
  }
  return [...out];
}

/* Backing is indexed, but only for words that mean nothing else.

   "hessian" appears nowhere except as a backing, so indexing it turns 26
   failed searches a quarter into 230 results. "jute" is different: it is the
   backing on 138 rugs AND the material of 69, and somebody typing jute - 3,779
   searches a quarter - wants a jute rug, not a polypropylene one with a jute
   underside. So a backing word is only indexed if no product uses it as a
   material or in a title. */
const SURFACE = new Set();
CATALOG.forEach(p => {
  toks((p.mat || "") + " " + (p.t || "")).forEach(w => SURFACE.add(w));
});

const DOCS = CATALOG.map((p, i) => {
  const title = toks(p.t), type = toks(p.ty), tags = toks((p.tg||[]).join(" "));
  const attrs = toks([p.mat, p.co, p.rm, p.st].filter(Boolean).join(" "));
  const backing = toks(p.bk || "").filter(w => !SURFACE.has(w));
  /* 12 Oct 2026: names a shopper knows that were nowhere in the bag. The
     range is in the parent SKU ("Catalina_Florrie_Green") - "catalina
     florrie" found nothing because Florrie is not in the title. Collections
     carry the collaborations ("Caoimhe The Big Hill House"). The description's
     colour words (dc) are the second and third colours: a product holds one
     colour, so "green and pink" found nothing. Lowest weight, so the rug's
     own colour always ranks first. */
  const range = toks(String(p.ps || "").replace(/[_-]+/g, " ")).filter(w => /^[a-z]{3,}$/.test(w) && w !== "kukoon");
  const colls = toks((p.cl || []).join(" "));
  const descCo = toks((p.dc || []).join(" "));
  const bag = new Map();
  const put = (ws, w) => ws.forEach(x => bag.set(x, Math.max(bag.get(x)||0, w)));
  put(backing, 1); put(descCo, 1); put(colls, 2); put(range, 3); put(sizeTokens(p.sz), 4); put(attrs, 2);
  put(tags, 3); put(type, 6); put(title, 10);
  return {i, p, bag, titleStart: title[0] || ""};
});

/* declared here rather than beside the merchandising helpers: search() uses it
   for the browse ordering and runs before that point in the file */
function isAccessory(p){ return (p.ty || "").toLowerCase() === "underlay"; }

const RANK = new Map();
CATALOG.map((p, i) => [i, p.s || 0]).sort((a, b) => b[1] - a[1]).forEach(([i], r) => RANK.set(i, r));

const VOCAB = new Set();
DOCS.forEach(d => d.bag.forEach((_, w) => VOCAB.add(w)));
const VOCAB_ARR = [...VOCAB];
const DF = new Map();
DOCS.forEach(d => d.bag.forEach((_, w) => DF.set(w, (DF.get(w) || 0) + 1)));

/* Damerau, not plain Levenshtein: a swapped pair of adjacent letters costs
   one edit, not two.

   "biege" is 15 real searches a quarter and returned nothing here, because
   beige -> biege is a transposition and straight Levenshtein scores that as 2
   while a five-letter word is only allowed 1. Swapping two letters is the
   single most common way anyone mistypes a word, so it has to cost what a
   typo costs. Same fix carries "circel" and "recieve"-shaped errors. */
function within(a, b, max){
  if (Math.abs(a.length - b.length) > max) return false;
  let prev2 = null;
  let prev = Array.from({length: b.length + 1}, (_, j) => j);
  for (let i = 1; i <= a.length; i++){
    const cur = [i];
    let best = i;
    for (let j = 1; j <= b.length; j++){
      let v = Math.min(prev[j] + 1, cur[j-1] + 1, prev[j-1] + (a[i-1] === b[j-1] ? 0 : 1));
      if (i > 1 && j > 1 && a[i-1] === b[j-2] && a[i-2] === b[j-1])
        v = Math.min(v, prev2[j-2] + 1);
      cur[j] = v; if (v < best) best = v;
    }
    if (best > max) return false;
    prev2 = prev; prev = cur;
  }
  return prev[b.length] <= max;
}

/* What customers call things, against what we call them.

   Seeded from Algolia's no-results list for the last 90 days - these are real
   failed searches, not guesses. Each entry maps the customer's word onto the
   words the catalogue actually uses; anything not in the catalogue is ignored,
   so a stale entry costs nothing.

   This wants to become a table merchandising can edit. Hard-coded for now. */
/* ---------- what the shop can change without a deploy ----------------

   window.KUKOON_SETTINGS arrives from the dashboard, through a file on
   KR-APP-003. It is merged over what the theme shipped with, so anything
   missing or unreachable simply leaves the built-in behaviour in place - a
   search that cannot reach the settings is a normal search, not a broken one.

   Everything here is defensive on purpose: this document is written by a
   person through a form, and while the dashboard validates it, the search
   should not be the thing that discovers a bad entry. Anything it does not
   recognise is ignored rather than trusted. */
function applySettings(s){
  if (!s || typeof s !== "object") return;

  // the learned-ranking test: split (default) | all | off (Search Radar)
  if (s.learned_rank === "split" || s.learned_rank === "all" || s.learned_rank === "off") LEARNED_MODE = s.learned_rank;

  // the pills under the box: the shop's list wins if it has one
  if (Array.isArray(s.popular) && s.popular.length){
    const clean = s.popular.filter(t => typeof t === "string" && t.trim()).slice(0, 12);
    if (clean.length){ POPULAR.length = 0; clean.forEach(t => POPULAR.push(t.trim().toLowerCase())); }
  }
  // John's phone-and-tablet list, if he set one; otherwise phones take the
  // first PHONE_POPULAR of the desktop list
  if (Array.isArray(s.popular_mobile) && s.popular_mobile.length){
    POPULAR_MOBILE.length = 0;
    s.popular_mobile.filter(t => typeof t === "string" && t.trim()).slice(0, 12)
      .forEach(t => POPULAR_MOBILE.push(t.trim().toLowerCase()));
  }

  /* Synonyms, merged into the built-in map rather than replacing it. The
     engine reads SYNONYM[word] as a list of words to search instead, and
     filters them against the vocabulary itself - so a synonym pointing at a
     word no product uses quietly does nothing, which is the right failure. */
  if (s.synonyms && typeof s.synonyms === "object"){
    for (const k of Object.keys(s.synonyms)){
      const from = String(k || "").trim().toLowerCase();
      const to = String(s.synonyms[k] || "").trim().toLowerCase();
      if (!from || !to || from === to) continue;
      if (from.includes(" ") || to.includes(" ")){ PHRASES.set(norm(from), norm(to)); continue; }
      /* Both sides in the index's own form (21 Oct 2026): the vocabulary and the
         typed word are stemmed ("kids" -> "kid", "runners" -> "runner"), so
         "children -> kids" pointed at a word the index doesn't hold and a key
         like "boys" was never looked up. 30 synonyms did nothing. */
      for (const f of new Set([from, stem(from)])){
        const already = SYNONYM[f] || [];
        SYNONYM[f] = [...new Set(already.concat([to, stem(to)]))];
      }
    }
  }

  // pinned products: a term -> up to six handles, first in that order
  if (s.pins && typeof s.pins === "object" && !Array.isArray(s.pins)){
    for (const k of Object.keys(s.pins)){
      const term = norm(k);
      const handles = (Array.isArray(s.pins[k]) ? s.pins[k] : [])
        .map(h => String(h || "").trim().toLowerCase()).filter(Boolean).slice(0, 6);
      if (term && handles.length) PINS.set(term, handles);
    }
  }

  /* The Shop by row, replaced only if the shop sent at least one usable tile.
     Facet and flag names are checked against what the engine knows: an
     unknown facet would make tileMatch() throw and blank the panel. */
  // a tile may also be a link to a collection page (url), with or without a
  // facet for its count - the only urls accepted are this shop's collections
  const parseTiles = list => {
    const facets = new Set(GROUPS.map(g => g.key));
    const tiles = [];
    for (const t of list.slice(0, 8)){
      if (!t || typeof t !== "object") continue;
      const label = String(t.label || "").trim().slice(0, 24);
      if (!label) continue;
      const url = /^\/collections\/[a-z0-9-]+$/.test(String(t.url || "")) ? String(t.url) : "";
      let spec = null;
      if (t.query) spec = {q: String(t.query).trim().toLowerCase()};
      else if (t.flag === "washable" || t.flag === "pet") spec = {flag: t.flag};
      else if (facets.has(t.group) && t.value) spec = {g: t.group, v: String(t.value)};
      else if (url) spec = {};
      if (!spec) continue;
      if (url) spec.url = url;
      tiles.push([label, spec]);
    }
    return tiles;
  };
  if (Array.isArray(s.tiles) && s.tiles.length){
    const tiles = parseTiles(s.tiles);
    if (tiles.length){ TILES.length = 0; tiles.forEach(x => TILES.push(x)); }
  }
  if (Array.isArray(s.tiles_mobile) && s.tiles_mobile.length){
    const tiles = parseTiles(s.tiles_mobile);
    if (tiles.length){ TILES_MOBILE.length = 0; tiles.forEach(x => TILES_MOBILE.push(x)); }
  }

  // the filter groups' order, from Search Radar
  if (Array.isArray(s.facet_order)){
    const keys = new Set(GROUPS.map(g => g.key));
    FACET_ORDER = s.facet_order.map(k => String(k || "").toLowerCase()).filter(k => keys.has(k));
  }

  // terms the shop would rather answer with nothing than with what matches
  if (Array.isArray(s.exclude)) {
    for (const t of s.exclude){
      const term = String(t || "").trim().toLowerCase();
      if (term) EXCLUDED_TERMS.add(term);
    }
  }
}

/* Terms the shop has muted from the dashboard. Declared up here, beside the
   map it sits next to in meaning, because search() reads it and search() is
   defined long before the settings are applied. */
const EXCLUDED_TERMS = new Set();

/* Synonyms of more than one word - "door runner" -> "doormat", or one word
   meaning a phrase. Each word is its own AND-ed term, so a phrase can only
   ever be matched as a rewrite of the typed text, before it is split up.
   Longest first, so "long door runner" is not half-rewritten by a shorter key. */
const PHRASES = new Map([["animal print", "animal"]]);
/* A size half typed is a size, not a word (12 Oct 2026). "80cm x" found
   nothing while the shopper was still typing, because "80cm" became a word
   only two products contain. The end of the box is read as "starts with
   80x", which the size tokens answer. */
function halfSize(raw){
  return String(raw || "").replace(/(^|\s)(\d{2,3})\s*(?:cm)?\s*[x*\u00d7]\s*$/i, "$1$2x")
                          .replace(/(^|\s)(\d{2,3})\s*cm\s*$/i, "$1$2x");
}
function rewritePhrases(raw){
  // untouched unless a phrase is in it: normalising would break "2.5m x 3m"
  let q = " " + norm(raw) + " ";
  const keys = [...PHRASES.keys()].filter(k => q.includes(" " + k + " "))
                                  .sort((a, b) => b.length - a.length);
  if (!keys.length) return raw;
  for (const k of keys) q = q.split(" " + k + " ").join(" " + PHRASES.get(k) + " ");
  return q.trim();
}

/* Terms the shop has pinned products to, from the dashboard: term -> handles,
   in the order they should appear. Empty unless the dashboard says otherwise. */
const PINS = new Map();

const SYNONYM = {
  fluffy: ["shaggy"], fluffies: ["shaggy"], furry: ["shaggy"],
  chequered: ["check", "checker", "checked"], checkered: ["check", "checker", "checked"],
  // teal only - mapping these to "blue" as well returned 159 rugs, which is
  // an answer to "blue", not to "turquoise"
  turquoise: ["teal"], aqua: ["teal"],
  maroon: ["red", "wine", "burgundy"], burgundy: ["wine", "red"],
  pillow: ["cushion"], pillows: ["cushion"], cushions: ["cushion"],
  mat: ["doormat", "mat"], mats: ["doormat", "mat"],
  nonslip: ["underlay"], "non-slip": ["underlay"], antislip: ["underlay"],
  gripper: ["underlay"], grip: ["underlay"],
  hallway: ["hall", "runner"], corridor: ["hall", "runner"],
  circular: ["circle", "round"],
  // colour words we simply do not use. Each is a real no-results term from the
  // last 90 days, mapped to the nearest colour we DO stock rather than left to
  // return nothing - a shopper hunting aubergine will take a purple rug.
  wipeable: ["washable"], wipable: ["washable"],
  eggshell: ["cream"], mushroom: ["taupe", "beige"], taupe: ["taupe", "beige"],
  aubergine: ["purple", "plum"], raspberry: ["pink"], khaki: ["olive", "green"],
  terrocata: ["terracotta"], terracota: ["terracotta"],
  // animal print: cow, cheetah, giraffe and tiger are all zero. Leopard and
  // zebra exist, and "animal" is the tag they share.
  cow: ["animal", "zebra"], cheetah: ["animal", "leopard"],
  giraffe: ["animal"], tiger: ["animal", "leopard"], "animal print": ["animal"],
  // deliberately NOT jute -> hessian. Hessian is the BACKING on 230
  // polypropylene rugs; somebody searching jute wants a jute rug. Mapping it
  // took "jute" from 85 results to 423, most of them wrong, on a term that
  // gets 3,779 searches a quarter.
};

const resolveCache = new Map();
function resolve(word){
  if (resolveCache.has(word)) return resolveCache.get(word);
  let out;
  const syn = (SYNONYM[word] || []).filter(w => VOCAB.has(w));
  /* A single letter is always the start of a word. The catalogue really does
     contain "a", "b", "c" and "l" as tags - 145 products between them - and
     matching those is never what somebody typing one letter meant, so the
     one-letter words in the vocabulary are excluded from what it can match. */
  if (word.length === 1){
    const pre = VOCAB_ARR.filter(v => v.length > 1 && v[0] === word);
    const out1 = pre.length ? {kind:"prefix", words:pre} : {kind:"none", words:[]};
    resolveCache.set(word, out1);
    return out1;
  }
  const short = word.length <= 3;
  if (syn.length) out = {kind:"exact", words:[...new Set(syn.concat(VOCAB.has(word) ? [word] : []))]};
  else if (short){
    // treat a short word as a prefix, including itself - somebody typing "be"
    // means beige, not the two-letter tag that happens to exist
    const pre = VOCAB_ARR.filter(v => v.startsWith(word));
    out = pre.length ? {kind:"prefix", words:pre}
                     : (VOCAB.has(word) ? {kind:"exact", words:[word]} : {kind:"none", words:[]});
  }
  else if (VOCAB.has(word)){
    /* "multi" is a word on 4 products and the start of "multicolour" on 124,
       so "multi coloured rug" found nothing (12 Oct 2026). A rare exact word
       also takes in the longer words it starts, when they are on at least as
       many products as the word itself. */
    const n = DF.get(word) || 0;
    const ext = VOCAB_ARR.filter(v => v !== word && v.startsWith(word) && v.length <= word.length + 7 && (DF.get(v) || 0) >= n);
    out = {kind:"exact", words:[word].concat(ext)};
  }
  else {
    const pre = VOCAB_ARR.filter(v => v.startsWith(word));
    if (pre.length) out = {kind:"prefix", words:pre};
    else {
      // two edits from six letters up. "shaggie" is two from shaggy and was
      // returning nothing; below six letters two edits reaches half the
      // vocabulary and the results stop meaning anything.
      const max = word.length >= 6 ? 2 : (word.length >= 4 ? 1 : 0);
      // nearest first: if anything is one edit away, two-edit matches are not
      // considered at all. "washble" is one edit from washable and two from
      // Ashbee, and offering both put a rug range in with 382 washables.
      let fz = [];
      for (let d = 1; d <= max && !fz.length; d++)
        fz = VOCAB_ARR.filter(v => within(word, v, d));
      out = fz.length ? {kind:"fuzzy", words:fz} : {kind:"none", words:[]};
    }
  }
  resolveCache.set(word, out);
  return out;
}
const KIND_MULT = {exact:1, prefix:.8, fuzzy:.45};

/* Shape words are NOT in the searchable text - size lives on the variants as
   custom.size_category, which is a facet. So "circular" used to match nothing
   and "brown shaggy rug circular" returned zero, which is not what a shopper
   means: they mean the brown shaggy rugs, in the round.

   So a shape word resolves against that facet instead of the word bag. It
   stays a normal term otherwise - it still ANDs, still counts, and still
   appears in the cumulative narrowing readout. */
/* CIRCLES ONLY, and that is measured rather than cautious. Runner was tried
   and is actively worse: nearly every rug is sold in a runner size, so the
   facet matches 632 of 925 products and the top result becomes Rug Underlay.
   As plain text it matches 297 and leads with actual runners. Doormat and
   Doormat stays text - identical set either way, no gain.

   Cushion DOES earn it: text alone finds the 12 cushion-cover products, and
   the facet adds the three rugs that sell a cushion in the same design - Bala,
   Perla and Shannon - which a shopper searching "blue cushion" plainly wants
   and which no wording in their titles would ever match. */
const SHAPE_WORD = {
  circle: ["Circular"], circular: ["Circular"], round: ["Circular"],
  cushion: ["Cushion"], cushions: ["Cushion"],
  /* The size buckets are the merchandising team's own (custom.size_category),
     the same eight the live site filters on - so a shopper who types one is
     using the shop's own vocabulary and deserves an answer. Before this,
     "zoe beige large" found nothing at all: "large" only matched a title with
     the word in it, and no Zoe rug has that.

     "extra large" arrives as two words. "large" means Large OR Extra Large and
     "extra" means Extra Large, so the two AND together onto Extra Large only,
     while "large" on its own still finds both. */
  small: ["Small"], smalls: ["Small"],
  medium: ["Medium"],
  large: ["Large", "Extra Large"], larger: ["Large", "Extra Large"],
  extra: ["Extra Large"], xl: ["Extra Large"],
  /* "wide" only ever means the wide runner here, and without it "wide runner"
     could not tell itself apart from a runner. */
  wide: ["Wide Runner"],
  /* Runner and Doormat are deliberately NOT here. They read as things a rug
     IS, not sizes it comes in, and most rugs in the shop have a runner
     variant - adding them took "runner" from 290 results to 635, which is
     most of the catalogue and no answer at all. They keep matching on the
     title, the way they always have. */
};

const SHAPE_KEYS = Object.keys(SHAPE_WORD);

/* Resolved the same way as any other word: exact, then prefix, then one typo.
   Without this "circl" matched nothing and the dropdown stayed empty until the
   very last keystroke, which is the opposite of search-as-you-type. */
function shapeCats(w){
  let keys = SHAPE_KEYS.filter(k => k === w || k === stem(w));
  if (!keys.length && w.length >= 3) keys = SHAPE_KEYS.filter(k => k.startsWith(w));
  // two edits from six characters up: the shape list is tiny, so a looser
  // threshold than the general vocabulary costs nothing. "circel" is common.
  if (!keys.length && w.length >= 4)
    keys = SHAPE_KEYS.filter(k => within(w, k, w.length >= 6 ? 2 : 1));
  if (!keys.length) return null;
  const out = new Set();
  keys.forEach(k => SHAPE_WORD[k].forEach(c => out.add(c)));
  return out;
}

/* v27 (30 Sep 2026): "jute" opened on three £45 doormats, because their
   titles START with the word. A bare material or colour search means rugs;
   doormats, cushions and bath mats follow them unless the shopper typed one
   of those words. */
const SMALL_WORDS = new Set(["doormat", "doormats", "door", "mat", "mats", "cushion", "cushions",
  "cover", "covers", "bath", "bathmat", "bathroom", "underlay", "entrance", "welcome", "coir"].map(w => stem(w)));
function smallThing(p){
  return isAccessory(p) || /\b(doormat|door mat|cushion|bath ?mat|underlay)\b/i.test(p.t || "");
}

/* v27: the features a shopper types as words. "pet friendly" found nothing -
   it is a feature on the product, not a word in its title - so these phrases
   become the feature itself: the rest of the query, pet-friendly only. */
const FEATURE_PHRASES = [
  /* "plain" was 44 dead searches a fortnight and no product says it. Plain
     here means one colour, no pattern: the shaggies, and the solid or
     mottled rugs whose titles name no pattern (12 Oct 2026). */
  [/\b(plain|solid|single colou?r)\b/, "plain"],
  [/\b(pet|pets|dog|dogs|cat|cats|puppy)\s*(friendly|proof|safe)\b/, "pet"],
  [/\b(liquid|spill|stain|water)\s*(repellent|resistant|proof)\b/, "spill"],
];
const FEATURE_TEST = {
  pet: p => p.pet || (p.ft || []).includes("Pet Friendly"),
  spill: p => (p.ft || []).includes("Liquid Repellent"),
  plain: p => !/multi/i.test(p.co || "") && (/shaggy/i.test(p.st || "") ||
    (/\b(plain|solid|mottled|tonal|natural)\b/i.test(p.t || "") &&
     !/(pattern|geometric|floral|stripe|border|trellis|aztec|abstract|check|medallion|damask|oriental|persian|tribal|boho)/i.test((p.t || "") + " " + (p.st || "")))),
};

/* Learned ranking (21 Oct 2026, Jack). The nightly build puts on each product
   the searches its buyers came from: p.lr = {"green": 10, "pink rug": 6}. For a
   shopper in the "learned" group, a product moves up that many places for that
   search - never past a pin, never when it is sold out. "current" keeps today's
   order, so the two can be compared (Search Radar). Group kept per browser;
   ?srank=learned / ?srank=current forces it for checking. Search Radar's
   settings (learned_rank) can switch the test off or put everyone on it. */
let LEARNED_MODE = "split";   // split | all | off
/* VERSION 2 (26 Oct 2026, Jack). Version 1 (21-26 Oct) was a draw - more clicks
   and adds, no more orders - and is parked (search-ranking-v1-result-2026-10-26).
   Fresh 50/50 groups (kukoon.srank2.ab), so nobody carries over from version 1.
   For the "learned" half, on top of what the nightly build learnt (p.lr):
     - a search's 1st-3rd choice (lr 101-103) goes to 1st / 3rd / 5th after pins;
       4th-12th move up 10 down to 1 places, as before
     - the base ranking counts sales on a sliding scale (no cap at 400 sold) and
       gives a smaller "title starts with the word" bonus to colour searches
     - positions 8 and 12 test a product that search rarely shows (deep in the
       results, few sales or new), a different one each day - how new rugs get seen
     - any error here: today's order, never a broken search
   The "current" half keeps today's order and today's ranking exactly. */
let SRANK = null;
function srankGroup(){
  if (LEARNED_MODE === "off") return "current";
  if (LEARNED_MODE === "all") return "learned";
  if (SRANK) return SRANK;
  try {
    const f = new URLSearchParams(location.search).get("srank");
    if (f === "learned" || f === "current") localStorage.setItem("kukoon.srank2.ab", f);
    SRANK = localStorage.getItem("kukoon.srank2.ab");
    if (SRANK !== "learned" && SRANK !== "current"){
      SRANK = Math.random() < 0.5 ? "learned" : "current";
      localStorage.setItem("kukoon.srank2.ab", SRANK);
    }
  } catch (e) { SRANK = "current"; }
  return SRANK;
}
const isV2 = () => srankGroup() === "learned";
// the key the nightly build learns under: "runners" and "runner" are one search
const learnKey = raw => norm(raw).split(" ").filter(Boolean).map(stem).join(" ");
const TEST_SLOTS = [7, 11];          // 8th and 12th
function dayHash(str){ let h = 2166136261; for (const c of str) { h ^= c.charCodeAt(0); h = Math.imul(h, 16777619); } return h >>> 0; }
function learnedOrder(raw, res){
  if (!res || !res.and || res.and.length < 2 || !isV2()) return res;
  try {
    const t = learnKey(raw);
    if (!t) return res;
    const pins = PINS.get(norm(raw)) || [];
    let fixed = 0;
    while (fixed < res.and.length && pins.indexOf(res.and[fixed].d.p.h) !== -1) fixed++;
    let and = res.and.map((r, i) => {
      const lift = i < fixed || r.d.p.oos ? 0 : ((r.d.p.lr || {})[t] || 0);
      if (lift > 100) return {r, k: Math.min(i, fixed + (lift - 101) * 2) - 0.6 + i / 1e4};   // into the top 6
      return {r, k: lift ? Math.max(fixed, i - lift) - 0.5 + i / 1e4 : i};
    }).sort((a, b) => a.k - b.k).map(x => x.r);
    // test slots: only on searches with plenty of results
    if (and.length > 30){
      // a strong match only: every searched word in its own title (a blue runner
      // matched on a tag has no business in a "beige" test slot)
      const qs = t.split(" ");
      const inTitle = p => { const w = norm(p.t).split(" ").map(stem); return qs.every(q => w.indexOf(q) !== -1); };
      const deep = and.slice(24).filter(r => !r.d.p.oos && !r.d.p.hide && !smallThing(r.d.p) && !/stair|cut to measure/i.test(r.d.p.t || "") && inTitle(r.d.p) && ((r.d.p.s || 0) < 30 || (r.d.p.tg || []).indexOf("New") !== -1));
      if (deep.length){
        const day = new Date().toISOString().slice(0, 10);
        const picks = [];
        TEST_SLOTS.forEach((slot, n) => {
          const c = deep[dayHash(day + "|" + t + "|" + n) % deep.length];
          if (c && picks.indexOf(c) === -1) picks.push(c);
        });
        and = and.filter(r => picks.indexOf(r) === -1);
        picks.forEach((c, n) => and.splice(Math.min(TEST_SLOTS[n], and.length), 0, c));
      }
    }
    return Object.assign({}, res, {and});
  } catch (e) {
    return res;      // the safety net: a fault here is today's order, never a broken search
  }
}

function search(raw){
  return colourOrder(raw, learnedOrder(raw, searchCore(raw)));
}
/* A search that is only a colour ("red", "green rugs", "sage green") is a
   shopper browsing a colour (27 Oct 2026, John's "red"). Title matching put
   the cut-to-measure carpets first - "Red Hard Wearing Runner", the red
   event carpet - because the colour is the first word of their titles. Now
   the rugs that really are that colour come first, best sellers first - the
   colour in the title, as the rug's main colour, or the rug is in that
   colour's collection (that is how Faro, terracotta and green, leads "red",
   as the team placed it) - then the other matching rugs as before, then
   carpets, stair runners, doormats, cushions and mats. Only the order
   changes: every result is still there. A shopper who types "red carpet" or "red stair" is
   not browsing a colour, so it doesn't apply. */
const COLOUR_ONLY_EXTRA = new Set(["rug", "rugs", "colour", "color", "light", "dark"].map(w => stem(w)));
const cutCarpet = p => /\b(stair|cut to measure|carpet)\b/i.test(p.t || "") ||
  /^(concorde|sunny|sc\s)/i.test(p.sku || "") || /^(concorde|sunny red)$/i.test(p.vendor || "");
function colourOrder(raw, res){
  try {
    if (!res || !res.and || res.and.length < 2) return res;
    const words = tok(String(raw || "").toLowerCase());
    if (!words.length || words.length > 3) return res;
    const colours = [];
    for (const w of words) {
      if (COLOUR_WORDS.has(w) || COLOUR_WORDS.has(stem(w))) colours.push(stem(w));
      else if (!COLOUR_ONLY_EXTRA.has(stem(w))) return res;
    }
    if (!colours.length) return res;
    const isColour = p => {
      const title = new Set(toks(p.t || "")), main = stem(String(p.co || "").toLowerCase());
      const colls = (p.cl || []).map(c => stem(String(c).toLowerCase()));
      return colours.every(c => title.has(c) || main === c || colls.indexOf(c) !== -1);
    };
    const later = p => p.oos || smallThing(p) || cutCarpet(p);
    const rugs = res.and.filter(r => !later(r.d.p));
    const first = rugs.filter(r => isColour(r.d.p)).sort((a, b) => (b.d.p.s || 0) - (a.d.p.s || 0));
    const second = rugs.filter(r => !isColour(r.d.p));
    const rest = res.and.filter(r => later(r.d.p));
    return Object.assign({}, res, {and: first.concat(second, rest)});
  } catch (e) { return res; }
}
function searchCore(raw){
  let text = String(raw || "").toLowerCase();
  /* "rug not washable": "not" matched nothing and killed the search. Now the
     word after it is taken out of the rugs instead (12 Oct 2026). */
  const nots = [];
  text = text.replace(/\b(?:not|without)\s+([a-z]{3,})/g, (_, w) => { nots.push(w); return " "; });
  if (nots.length){
    const res = searchCore(text.replace(/\s+/g, " ").trim() || "rug");
    const bad = nots.map(w => resolve(stem(w)).words);
    const ok = r => !bad.some(ws => ws.some(v => r.d.bag.has(v))) &&
                    !nots.some(w => /^wash/.test(w) && r.d.p.wash);
    return Object.assign({}, res, {and: res.and.filter(ok), near: (res.near || []).filter(ok)});
  }
  const wants = [];
  for (const [re, key] of FEATURE_PHRASES) if (re.test(text)) { wants.push(key); text = text.replace(re, " "); }
  if (wants.length){
    const res = searchWords(text.replace(/\s+/g, " ").trim(), raw);
    const keep = r => wants.every(k => FEATURE_TEST[k](r.d.p));
    return Object.assign({}, res, {and: res.and.filter(keep), near: res.near && res.near.filter(keep), features: wants});
  }
  return searchWords(raw, raw);
}

function searchWords(raw, asked){
  // a term the shop has muted answers like a term nothing matches: the
  // no-results screen, with its help links and its best sellers
  if (EXCLUDED_TERMS.has(String(asked || raw || "").trim().toLowerCase()))
    return {terms: [], and: [], orCount: 0};
  let qWords = tok(rewritePhrases(halfSize(raw)));
  const kept = qWords.filter(w => !FILLER.has(w));
  if (kept.length) qWords = kept;
  if (!qWords.length){
    /* Nothing typed is still a question - "show me the shop" - and the shop
       answers it with what people buy, not with whatever is first
       alphabetically. That opened on a coir doormat and three outlet rugs
       carrying one review between them. Accessories go last: underlay
       outsells every rug three to one and nobody browses for it. */
    const browse = DOCS.map(d => ({d, score:0}))
      .sort((a, b) => (a.d.p.oos ? 1 : 0) - (b.d.p.oos ? 1 : 0) ||
                      (isAccessory(a.d.p) ? 1 : 0) - (isAccessory(b.d.p) ? 1 : 0) ||
                      (b.d.p.s || 0) - (a.d.p.s || 0));
    return {terms:[], and:browse, orCount:DOCS.length};
  }
  const terms = qWords.map(w => {
    const r = resolve(stem(w));
    const hits = new Set();
    DOCS.forEach(d => { for (const v of r.words) if (d.bag.has(v)) { hits.add(d.i); break; } });
    // a shape word ADDS its facet matches rather than replacing the text ones,
    // so nothing a title would have matched is ever lost
    const cats = shapeCats(w);
    if (cats) {
      DOCS.forEach(d => {
        if ((d.p.scs || []).some(c => cats.has(c) && !hiddenFrom(d.p, c))) hits.add(d.i);
      });
      /* Hiding has to beat the text match too. "Rustic Jute Round Natural
         Circle Nursery Rug" has the word Circle in its title, so it came back
         for "circle" through plain text even though it is hidden from the
         shape. If a product is hidden from every shape this word means, it is
         hidden from the search for that word full stop. */
      DOCS.forEach(d => {
        if (hits.has(d.i) && [...cats].every(c => hiddenFrom(d.p, c))) hits.delete(d.i);
      });
    }
    const kind = (r.kind === "none" && cats) ? "exact" : r.kind;
    /* A size we do not sell - "juliette runner 120 x 300" - must not turn a
       good search into nothing. It stops filtering and instead ranks each
       product by how close its nearest size is: Juliette runners first. */
    const dim = /^(\d{2,3})x(\d{2,3})$/.exec(w);
    if (dim && !VOCAB.has(w)){
      const W = +dim[1], H = +dim[2], near = new Map();
      let top = Infinity;
      DOCS.forEach(d => {
        let bd = Infinity;
        for (const v of d.bag.keys()){
          const m = /^(\d{2,3})x(\d{2,3})$/.exec(v);
          if (m) bd = Math.min(bd, Math.abs(m[1] - W) / W + Math.abs(m[2] - H) / H);
        }
        near.set(d.i, bd);
        top = Math.min(top, bd);
      });
      // near enough to be what they meant: within 35% of the size asked for,
      // or of the closest size anything in the shop comes in
      const reach = Math.max(0.35, top + 0.35);
      near.forEach((n, i) => { if (n <= reach) hits.add(i); });
      return {word:w, kind:"exact", words:[], hits, shape:null, soft:near};
    }
    return {word:w, kind, words:r.words, hits, shape:cats};
  });
  const or = new Set();
  terms.forEach(t => t.hits.forEach(i => or.add(i)));
  const scored = [];
  let V2RANK = false; try { V2RANK = isV2(); } catch (e) {}
  for (const d of DOCS){
    let score = 0, ok = true;
    for (const t of terms){
      if (!t.hits.has(d.i)) { ok = false; break; }
      let best = 0;
      if (t.soft){ const n = t.soft.get(d.i); score += n < Infinity ? Math.max(0, 3 - n * 4) : 0; continue; }
      for (const v of t.words){ const w = d.bag.get(v); if (w) best = Math.max(best, w); }
      score += best * KIND_MULT[t.kind];
    }
    if (!ok) continue;
    if (V2RANK){
      // version 2 (learned half): colour searches lean less on title wording, and
      // sales count on a sliding scale - 1,800 sold clearly beats 400
      if (d.titleStart === stem(qWords[0])) score += COLOUR_WORDS.has(stem(qWords[0])) ? 2 : 4;
      score += Math.min(4.5, Math.log10(1 + (d.p.s || 0)) / Math.log10(2001) * 4);
    } else {
      if (d.titleStart === stem(qWords[0])) score += 4;
      score += Math.min(d.p.s || 0, 400) / 400 * 2;
    }
    scored.push({d, score});
  }
  // sold out in every size goes to the back - kept, never hidden, because
  // it will be back and a shopper searching its name still wants to see it
  const askedSmall = qWords.some(w => SMALL_WORDS.has(stem(w)));
  const tier = p => askedSmall ? 0 : (smallThing(p) ? 1 : 0);
  scored.sort((a,b) => (a.d.p.oos ? 1 : 0) - (b.d.p.oos ? 1 : 0) ||
                       tier(a.d.p) - tier(b.d.p) ||
                       b.score - a.score || (b.d.p.s||0) - (a.d.p.s||0));

  /* Pinned products lead, in the shop's order, whether or not the words
     matched them - that is what pinning is for. Everything else follows in
     its own order, without the pinned ones repeated. */
  const pinned = PINS.get(norm(asked || raw));
  if (pinned){
    const byHandle = new Map(DOCS.map(d => [d.p.h, d]));
    const top = pinned.map(h => byHandle.get(h)).filter(Boolean)
                      .map(d => ({d, score: Infinity, pinned: true}));
    const keep = new Set(pinned);
    const rest = scored.filter(r => !keep.has(r.d.p.h));
    return {terms, and: top.concat(rest), orCount: Math.max(or.size, top.length)};
  }
  /* Nothing has every word (12 Oct 2026). 1,699 of the fortnight's dead
     multi-word searches were one word away from an answer. All the words are
     still required for a result - nothing is mixed in - but the closest set,
     missing the one word that killed it, is offered under a heading that
     says so. */
  if (!scored.length && qWords.length >= 2 && !NEAR_DEPTH){
    NEAR_DEPTH = true;
    try {
      let best = null;
      for (let i = 0; i < qWords.length; i++){
        const rest = qWords.filter((_, j) => j !== i).join(" ");
        const r = searchWords(rest, rest);
        if (r.and.length && (!best || r.and.length > best.rows.length)) best = {rows: r.and, gone: qWords[i]};
      }
      // "leopard rug" without leopard is every rug: no help, so not offered
      if (best && best.rows.length <= DOCS.length * 0.5) return {terms, and: [], orCount: or.size, near: best.rows, gone: best.gone};
    } finally { NEAR_DEPTH = false; }
  }
  return {terms, and:scored, orCount:or.size};
}
let NEAR_DEPTH = false;

/* ---------- facets ----------------------------------------------------
   Sourced from the merchandising team's OWN metafields, not scraped out of
   tags: custom.size_category on the variants (the same 8 buckets the live
   site shows), and Data.google_kukoon_colour / _room / _style on the product.
   So "Grey" means the buyer called it grey and the counts match admin.

   GROUPS:  size, colour, room, style are multi-select.
   Within a group the options are OR-ed; across groups they are AND-ed. That
   is what a shopper expects - "Small OR Medium, AND grey".

   Counts are DISJUNCTIVE: the number beside "Medium" ignores the current Size
   selection but respects Colour and Room. Without that, ticking one size drops
   every other size to zero and the facet becomes a dead end. */
/* sizes first, then shapes, then product types - anything missing from this
   list sorts to the FRONT (indexOf returns -1), so keep it complete */
const SIZE_ORDER = ["Small","Medium","Large","Extra Large","Runner","Wide Runner",
                    "Circular","Doormat","Cushion"];

/* Size by its real dimensions (Jack, 8 Oct 2026). "Medium" meant 120x170 on
   one rug and 160x230 on another, and the product page only ever shows
   "160cm x 230cm" - so the shopper could not tell which box their rug was in.
   The Size filter now lists the sizes as the product page writes them, read
   from each rug's own size options, and the shapes (Runner, Circular, ...)
   stay as they were underneath.

   The standard sizes are the ones at least 10 rugs come in, worked out from
   the catalogue so a new standard size appears by itself. An odd size within
   20% of a standard on both sides counts as that size (160x225 is a
   160x230); anything further off keeps its own label. Small, Medium, Large
   and Extra Large still work in old links, tiles and typed searches - they
   just are not offered in the list any more. */
const RECT_BUCKETS = new Set(["Small", "Medium", "Large", "Extra Large"]);
const DIM_RE = /^\s*(\d+)\s*cm\s*x\s*(\d+)\s*cm\s*$/i;
const SZ_IN = /(\d+)\s*cm\s*x\s*(\d+)\s*cm/i;
const dimLabel = (w, h) => w + "cm x " + h + "cm";
function rectDims(p){
  if (!(p.scs || []).some(v => RECT_BUCKETS.has(v))) return [];
  const out = [];
  for (const s of p.sz || []){
    // colour-picker listings write "120cm x 170cm / Grey" or "Navy / 80cm x 150cm"
    if (/runner|circle|round/i.test(s)) continue;
    const m = SZ_IN.exec(s);
    if (!m) continue;
    const w = Math.min(+m[1], +m[2]), h = Math.max(+m[1], +m[2]);
    // a 66 x 300 listed without the word Runner is a runner, not a rug size
    if (h / w >= 2.5) continue;
    out.push([w, h]);
  }
  return out;
}
const STD_DIMS = (() => {
  const c = new Map();
  CATALOG.forEach(p => new Set(rectDims(p).map(([w, h]) => dimLabel(w, h)))
    .forEach(k => c.set(k, (c.get(k) || 0) + 1)));
  return [...c].filter(([, n]) => n >= 10)
    .map(([k]) => { const m = DIM_RE.exec(k); return {k, w: +m[1], h: +m[2]}; });
})();
function snapDim(w, h){
  let best = null, gap = Infinity;
  for (const s of STD_DIMS){
    const g = Math.max(Math.abs(w - s.w) / s.w, Math.abs(h - s.h) / s.h);
    if (g < gap){ gap = g; best = s; }
  }
  return best && gap <= 0.2 ? best.k : dimLabel(w, h);
}
const SIZE_VALUES = new Map();
function sizeValues(p){
  let v = SIZE_VALUES.get(p);
  if (!v){
    v = [...new Set(rectDims(p).map(([w, h]) => snapDim(w, h)))]
      .concat((p.scs || []).filter(c => !RECT_BUCKETS.has(c)));
    SIZE_VALUES.set(p, v);
  }
  return v;
}
// what a size selection may match: the listed values, and the old buckets so
// a link or tile saying size=Large still finds the large rugs
const sizeMatchable = p => sizeValues(p).concat((p.scs || []).filter(c => RECT_BUCKETS.has(c)));
const dimArea = v => { const m = DIM_RE.exec(v); return m ? m[1] * m[2] : Infinity; };
const sizeSort = (a, b) => dimArea(a) - dimArea(b) ||
  SIZE_ORDER.indexOf(a) - SIZE_ORDER.indexOf(b) || a.localeCompare(b);

const GROUPS = [
  {key:"size",   label:"Size",   get:sizeValues, sort:sizeSort},
  {key:"colour", label:"Colour", get:p => p.co ? [p.co] : []},
  {key:"room",   label:"Room",   get:p => p.rm ? [p.rm] : []},
  {key:"style",  label:"Style",  get:p => p.st ? [p.st] : []},
];

/* Products hidden from a SHAPE, not from the shop.

   Kukoon lists some rugs twice: once as the full range with every size, and
   once as a dedicated circle listing. Both carry a Circular variant, so both
   turn up when a customer filters or searches for circles - the same rug,
   twice, with different photography. The dedicated listing is the better one
   to show, so the general listing is hidden from circles only. It still
   appears for every other search and filter.

   This is a display decision, not a data fix - the duplicate listings are a
   separate merchandising job. The reason is recorded on every line so nobody
   has to guess later why a product vanished from one filter. */
const SEARCH_EXCLUDE = {
  "dark-grey-trellis-living-room-rug":
    {Circular: "duplicate of Circle Round Dark Grey Trellis Living Room Rug"},
  "distressed-abstract-beige-area-rug":
    {Circular: "duplicate of Distressed Abstract Beige Circle Rug - Grace"},
  "faded-distressed-grey-oriental-pattern-rug":
    {Circular: "duplicate of Round Circle Faded Distressed Grey Oriental Rug"},
  "traditional-cream-motif-bordered-rug":
    {Circular: "duplicate of Traditional Cream Motif Round Rug"},
  "soft-teal-blue-shaggy-runner-rug":
    {Circular: "duplicate of Super Soft Teal Blue Shaggy Rug"},
  "plush-soft-silver-grey-shaggy-rug":
    {Circular: "duplicate listing - Plush Soft Greige Shaggy Rug - Zia"},
  "soft-blue-distressed-abstract-living-room-area-rug":
    {Circular: "duplicate of Soft Blue Abstract Circle Rug - Bedtime"},
  "patchwork-wine-living-room-rug":
    {Circular: "duplicate of Round Circle Patchwork Wine Rug"},
  "premium-sage-green-shaggy-rug-sage":
    {Circular: "duplicate of Premium Sage Green Shaggy Circle Rug - Sage"},
  "blue-oriental-distressed-vintage-rug":
    {Circular: "duplicate of Round Circle Blue Oriental Distressed Vintage Rug"},
  "gold-blue-distressed-living-room-rug":
    {Circular: "duplicate of Round Circle Gold Blue Distressed Living Room Rug"},
  "ochre-grey-patchwork-rug":
    {Circular: "duplicate listing"},
  "terracotta-red-warm-patchwork-living-room-rug":
    {Circular: "duplicate of Round Circle Patchwork Terracotta Rug"},
  // multi-colour parent listings - the individual colours are listed separately
  "premium-shaggy-rug-choose-your-colour": {Circular: "colour-picker parent listing"},
  "plush-soft-shaggy-area-rug": {Circular: "colour-picker parent listing"},
  // rugs that also sell a hidden "Cushion Cover" size: the card showed the
  // cushion photo and £25 on a rug page where the cushion can't be picked, next
  // to the real cushion product (Jack, 19 Oct 2026, "perla cushion")
  "washable-terracotta-distressed-boho-rug":
    {Cushion: "rug listing - the cushion is Bold Bohemian Cushion Cover"},
  "washable-earthy-flora-area-rug":
    {Cushion: "rug listing - the cushion is Earthy Floral Cushion Cover"},
  "rustic-jute-round-natural-circle-nursery-rug":
    {Circular: "duplicate of Rustic Jute Round Natural Circle Rug"},
};

const hiddenFrom = (p, cat) => Boolean((SEARCH_EXCLUDE[p.h] || {})[cat]);

function passesGroup(p, g){
  const chosen = sel[g.key];
  if (!chosen.size) return true;
  if (g.key === "size")
    return sizeMatchable(p).some(v => chosen.has(v) && !hiddenFrom(p, v));
  return g.get(p).some(v => chosen.has(v));
}

function passesFlags(p){
  const feats = (p.ft || []).map(featureName);
  if (sel.washable && !(p.wash || feats.includes("Machine Washable"))) return false;
  if (sel.pet && !(p.pet || feats.includes("Pet Friendly"))) return false;
  if (sel.spill && !feats.includes("Liquid Repellent")) return false;
  return true;
}

/* rows that pass every group EXCEPT `skip` - the basis for disjunctive counts */
/* Counts are computed the same way the facet counts are: how many results
   would remain if this one toggle were flipped on, with every other filter
   left as it is. */
/* Kukoon's own icons, from the sprite at the top of the page - one copy each,
   referenced by <use>, so the same drawing on 925 cards costs nothing. */
const icon = id => '<svg class="ic" aria-hidden="true"><use href="#' + id + '"/></svg>';
const ICON_WASH  = icon("ic-wash");
const ICON_PET   = icon("ic-pet");    // Kukoon's dog, not my paw print
const ICON_DROP  = icon("ic-spill");
const ICON_TICK  = '<svg class="ic tick" aria-hidden="true" viewBox="0 0 24 24" fill="none" ' +
  'stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round">' +
  '<path d="M5 12.5l4.5 4.5L19 7"/></svg>';

  '<path d="M5 12.5l4.5 4.5L19 7"/></svg>';

function qflagsHtml(rows){
  const defs = [
    ["washable", "Machine washable", ICON_WASH,
     p => p.wash || (p.ft || []).includes("Machine Washable")],
    ["pet", "Pet friendly", ICON_PET,
     p => p.pet || (p.ft || []).includes("Pet Friendly")],
    ["spill", "Liquid repellent", ICON_DROP,
     p => (p.ft || []).includes("Liquid Repellent")],
  ];
  /* which pills exist is settled by the search and the sidebar - never by the
     flags themselves, or ticking one makes another appear and the whole row
     jumps sideways under the cursor */
  const base = rows.filter(r => GROUPS.every(g => passesGroup(r.d.p, g)));
  return defs.map(([key, label, ico, test]) => {
    const n = rows.filter(r => {
      const p = r.d.p;
      if (!test(p)) return false;
      // disjunctive: this count answers "what would I get if I turned this
      // on", so it honours every OTHER flag but not itself
      for (const [k, , , t2] of defs) if (k !== key && sel[k] && !t2(p)) return false;
      return GROUPS.every(g => passesGroup(p, g));
    }).length;
    const on = sel[key];
    // it has to be able to change something: not none of them, not all of them
    const carried = base.filter(r => test(r.d.p)).length;
    // ...and "nearly all of them" is all of them: searching washable showed
    // "Machine washable 412" against 413 results (30 Sep 2026) - a chip that
    // repeats the question and pushes Pet friendly off the edge of a phone
    if (!on && (carried === 0 || carried >= base.length * 0.97)) return "";
    // a label round a real checkbox: the checkbox carries the state, the
    // keyboard and the screen reader, the label carries the look
    return '<label class="qflag' + (on ? " on" : "") + '">' +
      '<input type="checkbox" data-flag="' + key + '"' + (on ? " checked" : "") + '>' +
      // both marks live in the pill and cross-fade, so switching it on reads
      // as this control changing rather than as a different control arriving
      '<span class="swap">' + ico + ICON_TICK + '</span>' +
      '<span class="qlabel">' + label + '</span>' +
      '<span class="c">' + n.toLocaleString() + '</span></label>';
  }).join("");
}


function rowsExcept(rows, skip){
  return rows.filter(r => {
    const p = r.d.p;
    if (!passesFlags(p)) return false;
    return GROUPS.every(g => g.key === skip || passesGroup(p, g));
  });
}

function facetOptions(rows, g){
  const c = new Map();
  // a product hidden from a shape must not be counted towards it either, or the
  // Circular count promises 49 and the filter then delivers 41
  rowsExcept(rows, g.key).forEach(r => g.get(r.d.p).forEach(v => {
    if (g.key === "size" && hiddenFrom(r.d.p, v)) return;
    c.set(v, (c.get(v) || 0) + 1);
  }));
  let out = [...c.entries()];
  if (g.sort) out.sort((a,b) => g.sort(a[0], b[0]));
  else if (g.order) out.sort((a,b) => g.order.indexOf(a[0]) - g.order.indexOf(b[0]));
  else out.sort((a,b) => b[1]-a[1] || a[0].localeCompare(b[0]));
  // a chosen option always stays visible, even if nothing else narrows to it;
  // an old size bucket from a link (size=Large) is counted from the buckets
  sel[g.key].forEach(v => {
    if (c.has(v)) return;
    const n = g.key === "size" && RECT_BUCKETS.has(v)
      ? rowsExcept(rows, g.key).filter(r => (r.d.p.scs || []).includes(v)).length : 0;
    out.push([v, n]);
  });
  return out;
}

/* ---------- render ---------- */
const $ = id => document.getElementById(id);
const TOTAL = CATALOG.length;
let sortMode = "rel", last = null;
// how many cards are on screen; reset by every new search or filter
const PAGE = 48;
let shown = PAGE;
const sel = {size:new Set(), colour:new Set(), room:new Set(), style:new Set(),
             washable:false, pet:false, spill:false};

/* ---------- what the market charges ---------------------------------
   The index is in the shop's currency. The storefront may not be: on the
   German market every other price on the page is in euros, so a search that
   answers in pounds is the one thing on screen disagreeing with the rest.

   The rate is measured, not assumed. The theme renders a few real products'
   prices through Liquid - whatever this market actually charges, whether that
   comes from a conversion or a fixed price list - and passes them with their
   handles. Here they are looked up in the index and divided, and the median
   ratio is the market's. No probes (the artifact, or the shop's own market)
   means a ratio of 1 and nothing is converted. */
const MARKET = (function () {
  const c = (typeof cfg !== "undefined" && cfg) || {};
  const out = {rate: 1, code: c.currencyCode || "GBP", locale: c.locale || "en-GB"};
  const ratios = [];
  for (const probe of (c.priceProbes || [])){
    const row = CATALOG.find(p => p.h === probe.h);
    if (!row || !(row.min > 0) || !(probe.p > 0)) continue;
    ratios.push((probe.p / 100) / row.min);
  }
  if (ratios.length){
    ratios.sort((a, b) => a - b);
    // the median, so one product priced oddly on one market cannot move
    // every price in the search
    out.rate = ratios[Math.floor(ratios.length / 2)];
  }
  return out;
})();

/* Two decimals always: the storefront writes £30.00, not £30, and a search
   that drops them beside a grid that keeps them looks like a different shop. */
const money = n => {
  if (n == null) return "";
  const r = Math.round(n * MARKET.rate * 100) / 100;
  try {
    return new Intl.NumberFormat(MARKET.locale, {
      style: "currency", currency: MARKET.code,
      minimumFractionDigits: 2, maximumFractionDigits: 2
    }).format(r);
  } catch (e) {
    // an unknown currency code should not take the prices off the page
    return "£" + (Number.isInteger(r) ? r + ".00" : r.toFixed(2));
  }
};
/* A product label worth showing.

   realmedia.product_label is a free-text metafield and some products carry the
   literal word "None" in it. That rendered as a maroon badge reading None,
   which reads as a verdict on the rug. Anything that means "no label" is no
   label. */
const NO_LABEL = new Set(["none", "n/a", "na", "-", "--", "null", "false"]);
const labelOf = p => {
  const v = (p.lb || "").trim();
  return NO_LABEL.has(v.toLowerCase()) ? "" : v;
};

const esc = s => String(s).replace(/[&<>"]/g, c => ({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]));
/* The API pull returns urls that already carry a ?v= cache-buster, so this
   cannot assume it is adding the first parameter - "...png?v=123?width=600"
   is not a url, and the CDN returns nothing for it. That was a blank card. */
const img600 = u => u ? esc(u) + (u.indexOf("?") === -1 ? "?" : "&") + "width=600" : "";

/* Titles are left alone. Highlighting every matched word painted "Washable"
   yellow on all 382 results of a search for washable - a stripe across the
   grid that told nobody anything they had not just typed. */
function highlight(title, terms){
  return esc(title);
}

/* real reviews.rating, rounded to the nearest half for display */
const STAR_FULL = '<svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l3 6.6 7 .8-5.2 4.8 1.4 7L12 17.7 5.8 21.2l1.4-7L2 9.4l7-.8z"/></svg>';
const STAR_EMPTY = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M12 2l3 6.6 7 .8-5.2 4.8 1.4 7L12 17.7 5.8 21.2l1.4-7L2 9.4l7-.8z"/></svg>';
function starsFor(p){
  if (!p.r) return "";
  const filled = Math.round(p.r);
  let s = "";
  for (let i = 1; i <= 5; i++) s += (i <= filled ? STAR_FULL : STAR_EMPTY);
  return '<span class="stars" title="' + p.r.toFixed(2) + ' out of 5 from ' + p.rc +
         ' reviews"><span class="s">' + s + '</span>(' + p.rc.toLocaleString() + ')</span>';
}

/* realmedia.product_features, resolved from the metaobjects behind it - the
   same list the PDP shows. Ordered so the two the live card leads with appear
   first, then the rest by usefulness. Falls back to the custom.washable /
   custom.pet_friendly flags for the ~500 products with no feature list. */
const FEATURE_ORDER = ["Machine Washable","Liquid Repellent","Eco Friendly","Pet Friendly",
                       "Anti Slip Backing","Non-Slip","Easy Wipe Clean","Durable","Great Value"];
/* one product carries "T Machine Washable" - a typo in the metaobject, shown
   here as the real thing rather than reproducing the slip on screen */
const featureName = f => f === "T Machine Washable" ? "Machine Washable" : f;

function pillsFor(p){
  const names = [...new Set((p.ft || []).map(featureName))];
  names.sort((a, b) => {
    const ia = FEATURE_ORDER.indexOf(a), ib = FEATURE_ORDER.indexOf(b);
    return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
  });
  if (!names.length){
    if (p.wash) names.push("Machine Washable");
    if (p.pet) names.push("Pet Friendly");
  }
  return names.slice(0, 2).map((n, i) => [n, i ? "alt" : ""]);
}

/* featureTags() lived here - the three features as tags under each card.
   Taken off again: with features populated on 45.6% of the catalogue the row
   graded the data entry rather than the rug, and a reserved empty line under
   every second card is worse than no line at all. The icons stay on the
   filters, where they label a control. */

/* featureIcons() lived here: the three features drawn on each card, the way
   the live site does it. Taken off because product features are populated on
   45.6% of the catalogue, so the row reported data entry rather than product
   quality - and the rug with no icons loses to the identical rug with three.
   Worth restoring once coverage is fixed; the toggles keep the icons. */

/* realmedia.product_label - the merchandisers' own wording, not a rank I made
   up. 425 of 925 carry one; the rest correctly show no badge. */
function badgeFor(d){
  const lb = labelOf(d.p);
  if (!lb) return "";
  const cls = /^no\.?\s*1|best seller/i.test(lb) ? "badge"
            : /new/i.test(lb) ? "badge new" : "badge collab";
  return '<span class="' + cls + '">' + esc(lb) + '</span>';
}

function applyFilters(rows){
  return rows.filter(r => passesFlags(r.d.p) && GROUPS.every(g => passesGroup(r.d.p, g)));
}

function anySelected(){
  return GROUPS.some(g => sel[g.key].size) || sel.washable || sel.pet || sel.spill;
}

function clearFilters(){
  GROUPS.forEach(g => sel[g.key].clear());
  sel.washable = sel.pet = sel.spill = false;
}

/* Which filter groups are open (30 Sep 2026). The sidebar is redrawn on every
   tick, and each redraw used to snap the open groups back to the default -
   open Colour, tick Beige, and Colour stayed open but Room, opened a second
   ago, shut again. On a phone they start closed, all four on one screen with
   the button right under them; a desktop keeps Size open, as before. */
const OPEN_GROUPS = new Set();
let openSeeded = false;
const drawerWidth = () => typeof window !== "undefined" && window.matchMedia &&
  window.matchMedia("(max-width:860px)").matches;
/* The order the groups are listed in. Search Radar can set it (settings key
   facet_order) from which filters shoppers actually use; until it does, the
   order the shop has always had. */
let FACET_ORDER = [];
function orderedGroups(){
  if (!FACET_ORDER.length) return GROUPS;
  const at = k => { const i = FACET_ORDER.indexOf(k); return i === -1 ? 99 : i; };
  return GROUPS.slice().sort((a, b) => at(a.key) - at(b.key));
}
function sidebarHtml(and){
  // v27p: every group starts closed, Size too (Jack, 2 Oct 2026) - which
  // ones people open is logged below and decides the order in Search Radar
  if (!openSeeded){ openSeeded = true; }
  const count = applyFilters(and).length;
  const groups = orderedGroups().map(g => {
    const opts = facetOptions(and, g);
    if (!opts.length) return "";
    const open = OPEN_GROUPS.has(g.key) || sel[g.key].size ? " open" : "";
    const picked = sel[g.key].size ? '<span class="fpicked">' + esc([...sel[g.key]].join(", ")) + '</span>' : '';
    return '<details class="facet" data-key="' + g.key + '"' + open + '><summary><span>' + g.label + '</span>' + picked + '</summary>' +
      '<div class="opts">' + opts.map(([v, n]) =>
        '<label class="' + (n === 0 && !sel[g.key].has(v) ? "off" : "") + '">' +
        '<input type="checkbox" data-g="' + g.key + '" value="' + esc(v) + '"' +
        (sel[g.key].has(v) ? " checked" : "") + '>' +
        '<span>' + esc(v) + '</span><span class="c">(' + n.toLocaleString() + ')</span></label>'
      ).join("") + '</div></details>';
  }).join("");

  // Washable and Pet friendly live in the top bar now, not here - see qflagsHtml
  // the button says what it will show, so a tick that empties the page is
  // seen before the drawer closes, not after
  const done = '<div class="donewrap">' +
    (anySelected() ? '<button class="clearall" id="clearall">Clear all</button>' : '') +
    '<button class="done" id="drawerdone"' + (count ? '' : ' disabled') + '>' +
    (count ? 'Show ' + count.toLocaleString() + ' result' + (count === 1 ? '' : 's') : 'No matches - untick one') +
    '</button></div>';
  // on a phone the feature pills move in here, as a group like the others
  let feats = "";
  if (drawerWidth()){
    const base = and.filter(r => GROUPS.every(g => passesGroup(r.d.p, g)));
    const FT = [["washable", "Machine washable", p => p.wash || (p.ft || []).includes("Machine Washable")],
                ["pet", "Pet friendly", FEATURE_TEST.pet], ["spill", "Liquid repellent", FEATURE_TEST.spill]];
    const opts = FT.map(([k, label, test]) => {
      const n = base.filter(r => test(r.d.p)).length;
      if (!n && !sel[k]) return "";
      return '<label><input type="checkbox" data-flag="' + k + '"' + (sel[k] ? " checked" : "") + '>' +
        '<span>' + label + '</span><span class="c">(' + n.toLocaleString() + ')</span></label>';
    }).join("");
    const on = FT.some(([k]) => sel[k]);
    if (opts) feats = '<details class="facet" data-key="features"' + (on || OPEN_GROUPS.has("features") ? " open" : "") +
      '><summary><span>Features</span>' + (on ? '<span class="fpicked">' + FT.filter(([k]) => sel[k]).map(x => x[1]).join(", ") + '</span>' : '') +
      '</summary><div class="opts">' + opts + '</div></details>';
  }
  return '<div class="fhead"><h2 class="fh">Filters</h2>' +
    '<button class="fclose" id="drawerclose" aria-label="Close filters">&times;</button></div>' +
    '<div class="fbody">' + feats + groups +
    (anySelected() ? '<button class="clearall" id="clearall2">Clear all filters</button>' : "") +
    '</div>' + done;
}

function sortHtml(){
  return '<span class="fsel"><select id="fSort" aria-label="Sort results">' +
    [["rel","Relevance"],["sold","Best sellers"],["rated","Top rated"],
     ["asc","Price: low to high"],["desc","Price: high to low"]]
    .map(([v,l]) => '<option value="' + v + '"' + (sortMode===v?" selected":"") + '>' + l +
      '</option>').join("") +
    '</select><svg width="12" height="12" viewBox="0 0 24 24" fill="none" ' +
    'stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg></span>';
}

/* ---------- show the RIGHT photo -------------------------------------
   Cushions and circles here. Runners are handled in imageFor from the
   overhead RR/RRL photography only (see below), which answers the objection
   that follows: the room shots stay out of the grid.

   The same trick works technically for runners and circles - 88 products have
   a separate runner photograph - but it was tried and it looks worse. Those
   photos are a mix of product shots on white and lifestyle hallway scenes, so
   a results grid ends up half cut-out rugs and half room photos. Visual
   consistency beats literal accuracy here.

   Cushions are different: a cushion on a rug product is a genuinely different
   ITEM, not the same rug in another shape, so showing the rug is simply wrong.
   Four products, all photographed the same way as every other cushion. */
const SHAPE_IMAGE = [
  ["Cushion",  /\bcushion/i],
  ["Circular", /\b(circle|circular|round)/i],
];

/* Corrections that still need making in Shopify. The variant image there is
   the real source of truth - it drives the PDP, the basket and the order email
   as well as this grid - so every entry here is a note that the live data is
   wrong, not a place to art-direct from. Delete a line once Shopify is fixed.

   bold-bohemian-cushion: the cushion variant points at ...-06556, which is an
   off-centre crop of the back. The front is ...-06643, already the product's
   main image. */
const CDN = "https://cdn.shopify.com/s/files/1/0602/1070/8635/files/";
const IMAGE_FIX = {
  "bold-bohemian-cushion": {Cushion: "renuu-perla-multi-06643.jpg"},
  // (Bala's cushion override removed 29 Sep: the cushion variants now carry
  // their own photo in Shopify, which is where it belongs.)
};

function fixed(p, cat, url){
  const want = (IMAGE_FIX[p.h] || {})[cat];
  if (!want) return url;
  if (want.indexOf("http") === 0) return want;     // already a full url
  const hit = (p.im || []).find(u => u.indexOf(want) !== -1);
  return hit || url;
}

/* Which shape is this customer looking for right now?

   A ticked facet says it outright; otherwise the typed words do. Used for the
   photo AND for the link, so a search for circles lands on the circle rather
   than on the default 120x170 with the round size three clicks away. */
/* Shapes for DISPLAY - a wider list than the search uses, because a runner
   result should deep-link to the runner size even though runner images are
   deliberately off.

   Resolved with the same prefix and typo tolerance as the search itself. They
   used to be plain regexes needing the whole word, so typing "circl" narrowed
   the results to one circular rug while the card still showed the rectangle -
   the search had understood and the picture had not. */
const SHAPE_DISPLAY = {
  cushion: ["Cushion"], cushions: ["Cushion"],
  circle: ["Circular"], circular: ["Circular"], round: ["Circular"],
  runner: ["Runner", "Wide Runner"], runners: ["Runner", "Wide Runner"],
  doormat: ["Doormat"], doormats: ["Doormat"],
};
const DISPLAY_KEYS = Object.keys(SHAPE_DISPLAY);
// priority: the most specific shape wins when a query implies two
const SHAPE_ORDER = ["Cushion", "Circular", "Wide Runner", "Runner", "Doormat"];

function displayCats(w){
  let keys = DISPLAY_KEYS.filter(k => k === w || k === stem(w));
  if (!keys.length && w.length >= 3) keys = DISPLAY_KEYS.filter(k => k.startsWith(w));
  if (!keys.length && w.length >= 4)
    keys = DISPLAY_KEYS.filter(k => within(w, k, w.length >= 6 ? 2 : 1));
  const out = new Set();
  keys.forEach(k => SHAPE_DISPLAY[k].forEach(c => out.add(c)));
  return out;
}

function queryShapes(){
  const out = new Set();
  for (const w of tok($("q").value || "")) displayCats(w).forEach(c => out.add(c));
  return out;
}

function activeShape(p){
  const have = new Set([...Object.keys(p.vv || {}), ...Object.keys(p.vi || {})]);
  for (const cat of SHAPE_ORDER) if (have.has(cat) && sel.size.has(cat)) return cat;
  const typed = queryShapes();
  for (const cat of SHAPE_ORDER) if (have.has(cat) && typed.has(cat)) return cat;
  return "";
}

/* The size bucket this search is about, for THIS product.

   activeShape() answers the same question for the five shapes, because those
   drive the photograph. This is wider: any size the shopper ticked or typed
   that the product actually has a variant for. A ticked filter beats a typed
   word, and a shape beats a plain size - someone who typed "large runner"
   means the runner.

   Only categories the index carries a variant for count, so on an index built
   before sizes were mapped this simply finds fewer of them and the card
   behaves as it did. */
/* A shape is more specific than a size, and within the sizes the smaller
   reading wins: someone who typed "large" meant the Large, and gets the Extra
   Large only by saying so. */
const SIZE_PRIORITY = ["Cushion", "Circular", "Runner", "Wide Runner", "Doormat",
                       "Large", "Extra Large", "Medium", "Small"];

/* Every size the query names, read from both maps - the size words and the
   shape words that drive the photograph, because "runner" is in the second
   one and still names a variant.

   Words that each name a size narrow each other. "large" means Large or Extra
   Large, "extra" means Extra Large, and the pair agree on Extra Large - which
   is the only reading that lets "extra large" work without breaking "large".
   Where they agree on nothing, as in "large runner", both stand and the
   priority order decides. */
function typedCats(){
  const sets = [];
  for (const w of tok($("q").value || "")){
    const one = new Set();
    (shapeCats(w) || []).forEach(c => one.add(c));
    displayCats(w).forEach(c => one.add(c));
    if (one.size) sets.push(one);
  }
  if (!sets.length) return new Set();
  const union = new Set();
  sets.forEach(one => one.forEach(c => union.add(c)));
  let agreed = sets[0];
  for (const one of sets.slice(1)) agreed = new Set([...agreed].filter(c => one.has(c)));
  return agreed.size ? agreed : union;
}

function activeCat(p){
  const have = Object.keys(p.vv || {});
  if (!have.length) return "";
  const has = c => have.indexOf(c) !== -1;
  for (const cat of SIZE_PRIORITY) if (has(cat) && sel.size.has(cat)) return cat;
  const typed = typedCats();
  for (const cat of SIZE_PRIORITY) if (has(cat) && typed.has(cat)) return cat;
  return "";
}

function linkFor(p){
  const id = (p.vv || {})[activeCat(p) || activeShape(p)];
  return SHOP + encodeURIComponent(p.h) + (id ? "?variant=" + id : "");
}

/* ---------- live prices ------------------------------------------------

   The index price is a snapshot, and on the euro markets an estimate. So every
   price drawn is tagged with what it is the price OF - a product, or the one
   variant a size search landed on - and livePrices() replaces the text with
   what Shopify charges this market right now, via the Storefront API.

   One request for everything on screen, answers cached for the visit, and the
   index price left alone if anything goes wrong. No token (the artifact) means
   none of this runs and the page is exactly as before. */
const LIVE = {cache: new Map(), busy: false, again: false};

function liveCfg(){
  const c = (typeof cfg !== "undefined" && cfg) || {};
  return c.storefrontToken && c.storefrontUrl ? c : null;
}

// the variant a card links to, if it links to one - the same rule as linkFor
function liveVariant(p){
  return (p.vv || {})[activeCat(p) || activeShape(p)] || "";
}

// the tag a price span carries. "From" only when no single variant is meant
function liveAttrs(p){
  const v = liveVariant(p);
  const from = !v && p.min !== p.max ? "1" : "0";
  return ' data-live-h="' + esc(p.h) + '" data-live-v="' + esc(v) + '" data-live-from="' + from + '"';
}

function liveKey(el){
  return el.dataset.liveV ? "v:" + el.dataset.liveV : "p:" + el.dataset.liveH;
}

function liveMoney(amount, code){
  try {
    return new Intl.NumberFormat(MARKET.locale, {style: "currency", currency: code,
      minimumFractionDigits: 2, maximumFractionDigits: 2}).format(amount);
  } catch (e) {
    return code + " " + amount.toFixed(2);
  }
}

function livePrices(){
  if (!liveCfg()) return;
  // renders come in bursts - every keystroke redraws the panel - so this
  // waits a frame and runs once, and a call that lands mid-request is
  // remembered rather than dropped
  if (LIVE.busy) { LIVE.again = true; return; }
  LIVE.busy = true;
  requestAnimationFrame(() => fillLive().finally(() => {
    LIVE.busy = false;
    if (LIVE.again) { LIVE.again = false; livePrices(); }
  }));
}

async function fillLive(){
  const c = liveCfg();
  if (!c) return;          // no token (the artifact): leave every price as drawn
  const els = [...document.querySelectorAll(".kuk [data-live-h]:not([data-live-done])")];
  if (!els.length) return;

  const need = [...new Set(els.map(liveKey))].filter(k => !LIVE.cache.has(k)).slice(0, 60);
  if (need.length){
    const parts = need.map((k, i) => k.startsWith("v:")
      ? "a" + i + ': node(id: "gid://shopify/ProductVariant/' + k.slice(2).replace(/\D/g, "") +
        '") { ... on ProductVariant { availableForSale price { amount currencyCode } } }'
      : "a" + i + ": product(handle: " + JSON.stringify(k.slice(2)) +
        ") { availableForSale priceRange { minVariantPrice { amount currencyCode } } }");
    const country = /^[A-Z]{2}$/.test(c.country || "") ? c.country : "GB";
    try {
      const r = await fetch(c.storefrontUrl, {
        method: "POST",
        headers: {"Content-Type": "application/json",
                  "X-Shopify-Storefront-Access-Token": c.storefrontToken},
        body: JSON.stringify({query: "query @inContext(country: " + country + ") {" +
                              parts.join(" ") + "}"}),
      });
      const j = await r.json();
      need.forEach((k, i) => {
        const n = j && j.data && j.data["a" + i];
        const m = n && (n.price || (n.priceRange && n.priceRange.minVariantPrice));
        LIVE.cache.set(k, m ? {amount: Number(m.amount), code: m.currencyCode,
                               sale: n.availableForSale !== false} : null);
      });
    } catch (e) {
      return;   // the index prices stay, which is the right failure
    }
  }

  for (const el of els){
    if (!LIVE.cache.has(liveKey(el))) continue;   // beyond this batch - next pass
    el.dataset.liveDone = "1";
    const v = LIVE.cache.get(liveKey(el));
    if (!v) continue;
    el.textContent = (el.dataset.liveFrom === "1" ? "From " : "") + liveMoney(v.amount, v.code);
    if (!v.sale){
      el.classList.add("soldout");
      el.textContent += " · Sold out";
    }
  }
  // more tags than one batch holds: go round again for the rest
  if (document.querySelector(".kuk [data-live-h]:not([data-live-done])")) LIVE.again = true;
}

/* A search that names a size gets that size's price, not the product's
   cheapest. "zoe beige large" answering "From EUR 37.50" when the large is
   EUR 120 is a worse answer than no answer. Needs p.vp, which arrives with
   the next index build; without it this falls through to the from-price. */
function priceFor(p){
  if (p.min == null) return "";
  const exact = (p.vp || {})[activeCat(p)];
  if (exact != null) return money(exact);
  // lowest to highest, like the collection cards: "£30 – £515" (Tommy, 8 Oct)
  if (p.min === p.max || p.max == null) return money(p.min);
  const short = n => money(n).replace(/[.,]00(?=\D*$)/, "");   // £30, not £30.00, as on the cards
  return short(p.min) + " – " + short(p.max);
}

function imageFor(p){
  const vi = p.vi || {}, fix = IMAGE_FIX[p.h] || {};
  // An override counts as a source in its own right, not just a correction to
  // one. Bala's cushion photography is on the product but was never assigned
  // to the cushion variants, so p.vi has no Cushion entry to correct.
  const shot = cat => fix[cat] ? fixed(p, cat, vi[cat] || "") : vi[cat];
  // an explicitly ticked facet beats the typed words
  for (const [cat] of SHAPE_IMAGE) if (shot(cat) && sel.size.has(cat)) return shot(cat);
  // ...otherwise the typed words, resolved exactly as the search resolves them,
  // so the picture changes on the same keystroke the results do
  const typed = queryShapes();
  for (const [cat] of SHAPE_IMAGE) if (shot(cat) && typed.has(cat)) return shot(cat);
  /* Runners: the overhead RR / RRL shot by file name (p.ro, found by the index
     build), else the runner variant's own image. Keyed off activeCat, the same
     choice the link and the price make, so the photo, the price and the page
     it opens are always the same size. No overhead and no variant image means
     the usual photo, never a hallway room shot. */
  const run = activeCat(p);
  if (run === "Runner" || run === "Wide Runner"){
    const u = (p.ro || {})[run] || vi[run];
    if (u) return u;
  }
  return (p.im || [])[0] || "";
}

/* The styled shot - cushion on a chair, throw over the arm - rather than the
   plain overhead. Photography names these "...-2nd-angle-...", which is the
   only reliable signal we have; there is no metafield for it. Kept as a named
   pattern so it can be widened if the naming convention changes.

   It belongs on HOVER, not as the primary: a grid of overheads reads cleanly
   and consistently, and the styled shot is what sells it once you linger. */
const STYLED = /2nd-angle|cushion-adjusted/i;

/* Styled shots that exist on the CDN but are not yet in our cached catalogue,
   because the pull predates them. Same idea as IMAGE_FIX: each line is a note
   that our copy is stale, not a styling choice. A resync makes them redundant.  */
/* Keyed by SHAPE as well as handle: Perla sells both a circle and a cushion,
   and the cushion styling shot was appearing as the hover on the circle card. */
const HOVER_FIX = {
  // handle is a leftover from an earlier product - the title is Distressed Beige
  "distressed-red-cushion-1": {Cushion: CDN + "renuu-zoe-beige-cushion-2nd-angle-final.jpg"},
  "washable-terracotta-distressed-boho-rug": {Cushion: CDN + "renuu-perla-multi-cushion-final.jpg"},
  // the cushion styling shot lives on Earthy Floral Cushion Cover, not on the
  // rug product - Shopify cannot share an image between two products
  "washable-earthy-flora-area-rug": {Cushion: CDN + "renuu-shannon-cushion-2nd-angle-section.jpg"},
  // hover: the chair lifestyle shot added 29 Sep, replacing the old room shot
  "distressed-blue-damask-washable-rug":
    {Cushion: CDN + "renuu-bala-blue-cushion-chair-lifestyle-shot.webp"},
};

/* Decides the hover image outright, including deciding there shouldn't be one.

   This has to own the whole decision rather than returning a suggestion the
   caller can override. When a card shows a circle and the product has no
   circle room shot, the old fallback reached for the product's first image -
   which is the rectangle. Hovering a circle turned it into an oblong, on every
   shaggy rug where the only room photography is of the rectangular sizes.

   So: if the card is shape-specific, the hover is the matching shape or it is
   nothing at all. */
function hoverFor(p, primary){
  const vi = p.vi || {}, vh = p.vh || {}, fix = HOVER_FIX[p.h] || {}, im = p.im || [];
  // a runner card hovering to the rectangle is the circle bug again, so none
  if (primary && (Object.values(p.ro || {}).indexOf(primary) !== -1 ||
                  primary === vi.Runner || primary === vi["Wide Runner"])) return "";
  /* A hand-set hover applies even when the product has no variant image for
     that shape. Distressed Beige is a cushion-cover product - every variant is
     a cushion, so nothing is stored in p.vi, and keying the override off p.vi
     alone meant it never fired. */
  for (const cat of Object.keys(fix))
    if (!vi[cat] && fix[cat] && fix[cat] !== primary) return fix[cat];
  for (const cat of Object.keys(vi)){
    if (vi[cat] !== primary) continue;
    const alt = vh[cat] || fix[cat];
    if (alt && alt !== primary) return alt;
    /* A "-2nd-angle-" file is a styling shot OF THE CUSHION, so it is always
       the right shape and is a valid last resort here. Circles get no such
       fallback: their only other photography is of the rectangle. */
    if (cat === "Cushion")
      for (const u of im) if (u !== primary && STYLED.test(u)) return u;
    return "";
  }
  for (const u of im) if (u !== primary && STYLED.test(u)) return u;
  return (primary && primary !== (im[0] || "")) ? (im[0] || "") : (im[1] || "");
}

/* Cards link to the real product page. New tab, because the prototype is
   usually being demonstrated and losing the search results mid-sentence is
   worse than an extra tab. */
const SHOP = cfg.productUrlBase || "/products/";

/* Where this market lives. Shopify carries the market in the URL path -
   /en-ie/products/... - and routes.root_url is that prefix, empty on the
   primary market. Any link written without it silently moves the shopper to
   another country. Absent (the artifact) means the live domain, as before. */
const ROOT = (typeof cfg !== "undefined" && cfg && typeof cfg.rootUrl === "string")
  ? cfg.rootUrl.replace(/\/+$/, "") : "https://www.kukoonrugs.com";
/* The UK market's root_url is "/", not "". Kept, it made "//products/...",
   which a browser reads as a host called "products". Trailing slash off. */
const path = p => ROOT + p;

/* The shop's own review claim, not the search's. Supplied by the theme so it
   is changed in one place; the fallback is the line the PDP shows. */
const REVIEW_LINE = (typeof cfg !== "undefined" && cfg && cfg.reviewsLine)
  || "47,000+ reviews on Trustpilot";

/* The card carries the badge, the photo, the name, the price and the rating -
   and nothing else. Buy and Compare were mimicking the
   live site, but on a search result they compete with the only decision that
   matters here, which is which rug to open. The feature pills went the same
   way: two of them wrap onto a second line on a phone and squash the card. */
function cardHtml(r, terms){
  const p = r.d.p, im = p.im || [];
  const price = priceFor(p);
  const primary = imageFor(p);
  const hover = hoverFor(p, primary);
  const shots = primary
    ? '<img class="a" loading="lazy" src="' + img600(primary) + '" alt="' + esc(p.t) + '">' +
      // decoding="async" so a big hover shot never blocks the grid, and the
      // container is only marked ready once the bytes have actually arrived
      (hover ? '<img class="b" loading="lazy" decoding="async" ' +
        'onload="this.parentNode.classList.add(\'ready\')" src="' +
        img600(hover) + '" alt="">' : '')
    : '';
  const segs = (primary && hover)
    ? '<div class="segs"><i class="on"></i><i></i></div>'
    : '<div class="segs"></div>';
  return '<a class="card" href="' + esc(linkFor(p)) + '">' +
    '<div class="shot' + (primary && hover ? " dual" : "") +
    '">' + shots + badgeFor(r.d) + '</div>' + segs +
    '<div class="pname" title="' + esc(p.t) + '">' + highlight(p.t, terms) + '</div>' +
    '<div class="cardfoot"><span class="price"' + liveAttrs(p) + '>' + price + '</span>' +
    starsFor(p) + '</div></a>';
}

function render(){
  if (!last) return;
  const {terms, and, orCount} = last;
  const q = $("q").value.trim();

  $("crumb").textContent = q ? "Home / Search" : "Home / All Rugs";
  $("h1").textContent = q || "All Rugs";
  $("said").textContent = q
    ? ""
    : "Every published product — " + TOTAL.toLocaleString() + " rugs, doormats and accessories";

  const labOn = document.querySelector('.lab[data-lab="on"]');
  if (labOn){
  $("andN").textContent = and.length.toLocaleString();
  $("orN").textContent = orCount.toLocaleString();
  $("steps").innerHTML = !terms.length
    ? '<span>Nothing searched yet — showing the full catalogue.</span>'
    : '<span>Each word, cumulatively:</span>' + terms.map((t, i) => {
        const upto = search(terms.slice(0, i+1).map(x => x.word).join(" ")).and.length;
        return (i ? '<span class="arrow">→</span>' : '') +
          '<span><b>' + esc(t.word) + '</b> <i>' + upto.toLocaleString() + '</i></span>';
      }).join(" ");
  }

  const filtered = applyFilters(and);
  const sorted = filtered.slice();
  if (sortMode === "sold") sorted.sort((a,b) => (b.d.p.s||0) - (a.d.p.s||0));
  else if (sortMode === "rated") sorted.sort((a,b) => (b.d.p.r||0) - (a.d.p.r||0) || (b.d.p.rc||0)-(a.d.p.rc||0));
  else if (sortMode === "asc") sorted.sort((a,b) => (a.d.p.min ?? 1e9) - (b.d.p.min ?? 1e9));
  else if (sortMode === "desc") sorted.sort((a,b) => (b.d.p.max ?? -1) - (a.d.p.max ?? -1));

  const fb = $("side").querySelector(".fbody"), fbTop = fb ? fb.scrollTop : 0, sideTop = $("side").scrollTop;
  $("side").innerHTML = sidebarHtml(and);
  const fb2 = $("side").querySelector(".fbody");
  if (fb2) fb2.scrollTop = fbTop;
  $("side").scrollTop = sideTop;
  $("sortmount").innerHTML = sortHtml();
  $("qflags").innerHTML = qflagsHtml(last.and);
  const active = GROUPS.reduce((n, g) => n + sel[g.key].size, 0) +
    (sel.washable ? 1 : 0) + (sel.pet ? 1 : 0) + (sel.spill ? 1 : 0);
  const badge = $("filtercount");
  badge.textContent = active;
  badge.hidden = active === 0;
  $("resline").innerHTML = q
    ? 'Showing results for “<b>' + esc(q) + '</b>” (' + sorted.length.toLocaleString() + ')'
    : '<b>' + sorted.length.toLocaleString() + '</b> products';

  const nearRows = !sorted.length && last.near ? applyFilters(last.near) : [];
  if (!sorted.length && nearRows.length && !/\b(square|oval)\b/.test(norm(q))){
    $("resline").innerHTML = 'No rugs match all of \u201c<b>' + esc(q) + '</b>\u201d';
    $("results").innerHTML = '<div class="nearhead" style="margin:0 0 14px;font-size:15px">Nothing has every word. The closest, without \u201c<b>' + esc(last.gone) +
      '</b>\u201d (' + nearRows.length.toLocaleString() + '):</div>' +
      '<div class="grid">' + nearRows.slice(0, Math.min(shown, nearRows.length)).map(r => cardHtml(r, terms)).join("") + '</div>';
    livePrices();
    return;
  }
  if (!sorted.length){
    $("results").innerHTML = zeroHtml(q, terms);
    livePrices();
    return;
  }

  /* Paged rather than capped. It used to render the first 96 and stop, with
     no way to reach result 97 - so "runner" showed 96 of 297 and the rest
     simply did not exist. */
  const upto = Math.min(shown, sorted.length);
  $("results").innerHTML = '<div class="grid">' +
    sorted.slice(0, upto).map(r => cardHtml(r, terms)).join("") + '</div>' +
    (upto < sorted.length
      ? '<div class="morewrap"><button class="more" id="more">Show more</button>' +
        '<div class="morecount">Showing ' + upto.toLocaleString() + ' of ' +
        sorted.length.toLocaleString() + '</div></div>'
      : '');
  livePrices();
}

/* ---------- the dead end -------------------------------------------

   The old version said "no results", offered four hard-coded collection
   names and then showed the four biggest sellers - which, because it read
   the catalogue directly rather than through bestSellers(), led with Rug
   Underlay. A dead end that opens with underlay is not a recovery.

   Everything here is now derived: the nearest real word to what was typed,
   the same search with the word that killed it removed, categories with
   their true counts, and the terms that actually sell. */

/* Some searches are questions. 80-odd a quarter are "returns policy",
   "underfloor heating", "members25" - people using the search box as a help
   desk. Answering costs one card and only ever appears when the product
   search has already failed, so it can never crowd the results. */
/* The six pages that answer the questions people type into search - roughly 80
   a quarter are "returns policy", "delivery", "track my order". Links only:
   the pages carry the facts and stay current without anyone remembering that
   the search box has its own copy of them. */
const HELP = [
  {t: "Delivery", u: path("/pages/delivery"),
   k: ["delivery", "deliver", "shipping", "postage", "dispatch", "courier", "when"]},
  {t: "Returns", u: path("/pages/returns"),
   k: ["return", "returns", "refund", "exchange", "send back"]},
  {t: "Track your order", u: path("/pages/change-or-track-your-order"),
   k: ["track", "tracking", "order", "change", "cancel", "amend", "where"]},
  {t: "Contact us", u: path("/pages/contact"),
   k: ["contact", "phone", "email", "help", "number", "speak", "complaint"]},
  {t: "FAQs", u: path("/pages/faqs"),
   k: ["faq", "faqs", "question", "how", "underfloor", "heating", "care",
       "clean", "cleaning", "sample", "samples", "code", "discount", "voucher"]},
  {t: "About us", u: path("/pages/about-us"),
   k: ["about", "who", "kukoon", "story", "showroom"]},
];
function helpFor(q){
  const t = " " + norm(q) + " ";
  const hit = HELP.filter(e => e.k.some(k => t.indexOf(" " + k + " ") !== -1));
  if (!hit.length) return null;
  // the match first, then the rest - somebody asking about returns is often
  // one click from also wanting to track the order
  return hit.concat(HELP.filter(e => hit.indexOf(e) === -1));
}

/* The nearest real word. Typos within two edits never reach this screen - the
   engine resolves those - so what lands here is a word three or more edits
   out, or one we simply do not stock. */
function didYouMean(q){
  const words = tok(q);
  if (!words.length) return [];
  const out = [];
  for (let i = 0; i < words.length; i++){
    const w = words[i];
    // three-letter words have a near neighbour everywhere - "hip" came back as
    // "chic" - and two edits on a short word is a different word, not a typo
    if (w.length < 4) continue;
    let best = null, bd = 99;
    for (const v of VOCAB_ARR){
      if (v.length < 4 || Math.abs(v.length - w.length) > 2) continue;
      // one edit is a typo; two is only believable when it still starts the
      // same way, which is how people actually mistype
      const max = v[0] === w[0] ? 2 : 1;
      for (let d = 1; d <= max && d < bd; d++)
        if (within(w, v, d)){ bd = d; best = v; break; }
    }
    if (!best) continue;
    const alt = words.slice();
    alt[i] = best;
    const phrase = alt.join(" ");
    const n = search(phrase).and.length;
    if (n >= 3) out.push([phrase, n]);
  }
  return out.sort((a, b) => b[1] - a[1]).slice(0, 2);
}

/* Drop the word that killed it. Matching every word is the whole point of this
   engine, so the honest repair for "washable jute stair runner" is to say
   which word to give up and what that is worth - not to quietly fall back to
   OR and present 400 rugs as if they were matches. */
function dropWord(q){
  const words = tok(q);
  if (words.length < 2) return [];
  const out = [];
  for (let i = 0; i < words.length; i++){
    const phrase = words.filter((_, j) => j !== i).join(" ");
    const n = search(phrase).and.length;
    if (n >= 2) out.push([phrase, n, words[i]]);
  }
  // four words where no single one is the culprit: give up two, which is still
  // a better offer than a blank page
  if (!out.length && words.length >= 3)
    for (let i = 0; i < words.length; i++)
      for (let j = i + 1; j < words.length; j++){
        const phrase = words.filter((_, k) => k !== i && k !== j).join(" ");
        const n = search(phrase).and.length;
        if (n >= 2) out.push([phrase, n, words[i] + " " + words[j]]);
      }
  return out.sort((a, b) => b[1] - a[1]).slice(0, 3);
}

function zeroHtml(q, terms){
  const dead = terms.filter(t => t.kind === "none").map(t => t.word);
  const meant = didYouMean(q);
  const drops = /\b(square|oval)\b/.test(norm(q)) ? [] : dropWord(q);
  const help = helpFor(q);

  let why;
  const shapeMiss = /\b(square|oval)\b/.exec(norm(q));
  if (shapeMiss && !help)
    why = 'We don\u2019t make ' + shapeMiss[1] + ' rugs \u2014 round ones are the nearest shape.';
  else if (help)
    why = 'That looks like a question rather than a rug \u2014 these pages answer it.';
  else if (dead.length === 1)
    why = 'Nothing in the catalogue is called \u201c' + esc(dead[0]) + '\u201d.';
  else if (dead.length > 1)
    why = 'We do not stock anything called \u201c' + esc(dead.join('\u201d or \u201c')) + '\u201d.';
  else
    why = 'Each of those words exists on its own - just never on the same rug.';

  const fixes = meant.map(([phrase, n], i) =>
      '<button class="fix' + (i ? '' : ' lead') + '" data-try="' + esc(phrase) + '">' +
      'Search <b>' + esc(phrase) + '</b><span class="n">' + n.toLocaleString() + '</span></button>')
    .concat(drops.map(([phrase, n, gone], i) =>
      '<button class="fix' + (i || meant.length ? '' : ' lead') + '" data-try="' + esc(phrase) + '">' +
      'Without <b>' + esc(gone) + '</b><span class="n">' + n.toLocaleString() + '</span></button>'))
    .join("");

  const roundQ = shapeMiss ? norm(q).replace(/\b(square|oval)\b/, "round") : "";
  const roundFix = shapeMiss ? '<button class="fix lead" data-try="' + esc(roundQ) + '">Search <b>' + esc(roundQ) + '</b></button>' : '';
  const fixBox = ((fixes || roundFix) && !help)
    ? '<div class="fixbox"><div class="fixhead">' +
      (roundFix ? 'Try this instead' : meant.length ? 'Did you mean' : 'Try one word fewer') +
      '</div><div class="fixrow">' + roundFix + fixes + '</div></div>'
    : '';

  const answer = help
    ? '<div class="helprow">' + help.map((e, i) =>
        '<a class="helppill' + (i ? '' : ' lead') + '" href="' + e.u +
        '">' + esc(e.t) + '</a>').join("") + '</div>'
    : '';

  /* Ordered by units sold, not by how many products are in them: Cushions is
     fifteen lines and outsells Doormats' fifty-nine. */
  const cats = TILES.map(([label, t]) => {
    const m = tileMatch(t);
    return {label, t, n: m.length, sold: m.reduce((a, d) => a + (d.p.s || 0), 0)};
  }).sort((a, b) => b.sold - a.sold).map(c => {
    const attr = c.t.q ? 'data-try="' + esc(c.t.q) + '"'
               : c.t.flag ? 'data-flag="' + c.t.flag + '"'
                          : 'data-g="' + c.t.g + '" data-v="' + esc(c.t.v) + '"';
    return '<button class="zrow" ' + attr + '><span class="zname">' + esc(c.label) +
      '</span><span class="zn">' + c.n.toLocaleString() + '</span></button>';
  }).join("");

  const best = bestSellers(4);   // never underlay - it is an add-on, not a rug

  return '<div class="zero">' +
      '<h3 class="zerohead">No rugs match \u201c' + esc(q) + '\u201d</h3>' +
      '<p class="zerosub">' + why + (fixBox ? ' Here is the shortest way back.' : '') + '</p>' +
      answer + fixBox +
      '<div class="zhead">Or pick up where most people start</div>' +
      '<div class="zlist">' + cats + '</div>' +
    '</div>' +
    '<div class="startline">This month\u2019s best sellers</div>' +
    '<div class="grid">' + best.map(r => cardHtml(r, [])).join("") + '</div>' +
    /* Delivery, returns and the review score were all here. The footer says
       all three, and says the review score with a live widget rather than a
       number typed into a script - so the row now carries the one thing the
       page cannot get anywhere else: a person to ask. REVIEW_LINE is still
       here, and still comes from the theme, for whoever wants it back. */
    '<div class="zreassure">' +
      '<span>Still nothing? <a class="zlink" href="' + path("/pages/contact") + '">Talk to us</a> ' +
        'and we will find it for you.</span>' +
    '</div>';
}

/* ---------- shareable state ----------------------------------------
   The query and every filter go in the address bar, so a search can be sent
   to a colleague, bookmarked, or survive a reload. Written with replaceState
   rather than pushState on purpose: typing would otherwise leave one history
   entry per keystroke, and a back button that needs pressing nine times to
   leave a page is worse than one that leaves immediately. */
function writeUrl(){
  if (!cfg.isSearchPage) return;   // only /search's address is ours
  const u = new URLSearchParams();
  const q = ($("q").value || "").trim();
  if (q) u.set("q", q);
  GROUPS.forEach(g => { if (sel[g.key].size) u.set(g.key, [...sel[g.key]].join("|")); });
  if (sel.spill) u.set("spill", "1");
  if (sel.washable) u.set("washable", "1");
  if (sel.pet) u.set("pet", "1");
  if (sortMode !== "rel") u.set("sort", sortMode);
  const qs = u.toString();
  // A sandboxed frame - which is how this page is usually previewed - throws
  // SecurityError on the history API. Losing a shareable URL is a nuisance;
  // an exception on every keystroke would take the whole page down with it.
  try {
    history.replaceState(null, "", qs ? "?" + qs : location.pathname);
  } catch (e) { /* no addressable URL here, carry on */ }
}

function readUrl(){
  let u;
  try { u = new URLSearchParams(location.search); }
  catch (e) { return ""; }
  GROUPS.forEach(g => {
    const v = u.get(g.key);
    if (v) v.split("|").filter(Boolean).forEach(x => sel[g.key].add(x));
  });
  sel.washable = u.get("washable") === "1";
  sel.spill = u.get("spill") === "1";
  sel.pet = u.get("pet") === "1";
  const srt = u.get("sort");
  if (srt) sortMode = srt;
  return u.get("q") || "";
}

/* ---------- home vs results -----------------------------------------
   One page, two states. The shopper lands on home, searches, and the results
   view takes over - which is the journey, rather than a results page that was
   already open when they arrived. The logo goes back. */
function anyQuery(){
  return ($("q").value || "").trim().length > 0 || anySelected();
}

function setMode(){
  // the storefront's own pages are not ours to hide
  if (!cfg.isSearchPage) return;
  // And on /search the results view is the page. The prototype swapped in its
  // own home screen when the box was emptied; here that screen is the
  // storefront's homepage, which is somewhere else - so emptying the box left
  // a blank page between the header and the footer. It now browses everything,
  // which is what /search with no query should show anyway.
  $("home").hidden = true;
  $("resultsview").hidden = false;
}

/* Six ways in, each one a real filter or a real search, with a real count and
   a photograph borrowed from the best seller inside it. */
/* Three, and each opens its collection page (29 Sep). Six tiles squeezed the
   phone panel so the products underneath were cut off, and a tile that set a
   filter on /search could stack with another ("runners" + "washable") into a
   combination nobody could get out of. The collection pages are the shop's
   own, with their own filters. The count still comes from the index. */
/* Phones and tablets show the first THREE (the rest are marked .xtra and
   hidden under 1024px); a desktop panel has the room for all six. */
const TILES = [
  ["Runners", {g: "size", v: "Runner", url: "/collections/runner-rugs"}],
  ["Washable", {flag: "washable", url: "/collections/washable-rugs"}],
  ["Shaggy", {g: "style", v: "Shaggy", url: "/collections/shaggy-rugs"}],
  ["Circular", {g: "size", v: "Circular", url: "/collections/circle"}],
  ["Doormats", {g: "size", v: "Doormat", url: "/collections/doormats"}],
  ["Cushions", {g: "size", v: "Cushion", url: "/collections/cushions"}],
];
const PHONE_TILES = 3, PHONE_POPULAR = 4;
// set only by John's phone lists in Search Radar - empty means "first N of desktop"
const TILES_MOBILE = [], POPULAR_MOBILE = [];
const isPhone = () => typeof window !== "undefined" && window.matchMedia &&
  window.matchMedia("(max-width: 1023px)").matches;

/* Pick the picture that actually SHOWS the category.

   The first attempt took the best seller and used its main photo, which gave
   a Runners tile illustrated with a photo of underlay - underlay outsells
   every runner and comes in runner sizes - and a Cushions tile showing a rug.

   So: accessories are out, a room shot of the right shape wins, then the
   shape's own product photo, and the main image is the last resort. */
// a runner is roughly 1:4, and the tile is a square - crop one and you get a
// sliver of rug and a lot of white sweep, so those go straight to a room shot
const LONG = new Set(["Runner", "Wide Runner"]);

/* One definition of what a tile contains, used by the tile itself, by its
   product count and by the Shop by chip - they disagreed once and the chip
   counted rugs the tile did not show. */
function tileMatch(t){
  if (!t.q && !t.flag && !t.g) return [];      // a link-only tile has nothing to count
  if (t.q) return search(t.q).and.map(r => r.d).filter(d => !isAccessory(d.p));
  return DOCS.filter(d => !isAccessory(d.p) && (t.flag
    ? (t.flag === "washable" ? (d.p.wash || (d.p.ft || []).includes("Machine Washable"))
                             : (d.p.pet || (d.p.ft || []).includes("Pet Friendly")))
    : (t.g === "size" ? sizeMatchable(d.p) : GROUPS.find(g => g.key === t.g).get(d.p)).includes(t.v) &&
      !hiddenFrom(d.p, t.v)));
}

function tileImage(t, d){
  const p = d.p, im = p.im || [];
  if (t.v && (p.vh || {})[t.v]) return (p.vh)[t.v];            // that shape, in a room
  if (t.v && !LONG.has(t.v) && (p.vi || {})[t.v]) return (p.vi)[t.v];
  return im[1] || im[0] || "";                                  // a room shot if there is one
}

function tilesHtml(){
  // the same Vogue photograph is the top seller in several of these groups, so
  // without this two tiles sat side by side showing the identical picture
  const used = new Set();
  return TILES.map(([label, t], i) => {
    const match = tileMatch(t);
    const ranked = match.slice().sort((a, b) => (b.p.s || 0) - (a.p.s || 0));
    // walk down the best sellers until one offers a picture nobody has taken,
    // preferring sellers that have photography of this actual shape
    const suits = d => !t.v || (d.p.vh || {})[t.v] ||
      (LONG.has(t.v) ? (d.p.im || []).length > 1 : (d.p.vi || {})[t.v]);
    let im = "";
    for (const pass of [suits, () => true]){
      for (const d of ranked){
        if (!pass(d)) continue;
        const candidate = tileImage(t, d);
        if (candidate && !used.has(candidate)){ im = candidate; break; }
      }
      if (im) break;
    }
    if (im) used.add(im);
    return '<button class="tile" data-tile="' + i + '">' +
      '<span class="im">' + (im ? '<img loading="lazy" src="' + img600(im) + '" alt="">' : '') +
      '</span><span class="lab2">' + esc(label) + '</span>' +
      '<span class="n">' + match.length.toLocaleString() + ' products</span></button>';
  }).join("");
}

function renderHome(){
  $("tiles").innerHTML = tilesHtml();
  const best = bestSellers(8);
  $("homebest").innerHTML = best.map(r => cardHtml(r, [])).join("");
  livePrices();
}

/* ---------- measurement ------------------------------------------
   Pushed to the dataLayer the storefront already runs (GTM-TL67F7, feeding
   G-JLGD82J906). Nothing reads it on this prototype page, so every call is
   inert until it is dropped into the theme - which is the point: the wiring
   ships with the search rather than being remembered afterwards. */
const PII = /[^@\s]+@[^@\s]+\.[a-z]{2,}|\+?\d[\d\s-]{8,}/i;

/* Through dataLayer, not gtag: every other event on this storefront goes to
   GTM-TL67F7, and a second path into GA4 is how two sets of numbers that
   nobody can reconcile get created. */
function track(name, params){
  // a search box collects whatever people paste into it, and now and then
  // that is an email address or a phone number. Neither leaves this page.
  if (params.search_term && PII.test(params.search_term)) return;
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({event: name}, params));
  } catch (e) { /* measurement must never break the shop */ }
  logEvent(name, params);
}

/* The same event, to our own search log (snippets/search-log.liquid), which
   is what the dashboard reads. GA4 keeps its own copy; this one can be read
   back at the grain the search needs - every term, every zero, every click.
   One call feeds both, so they cannot drift apart. */
const LOG_TYPE = {view_search_results: "search", search_click: "click", search_refine: "refine"};
function logEvent(name, params){
  const type = LOG_TYPE[name];
  if (!type || typeof window.kukoonSearchLog !== "function") return;
  window.kukoonSearchLog(type, {
    term: params.search_term || "",
    results: params.results_count,
    handle: params.item_id,
    position: params.position,
    // a search carries the learned-ranking group, so the two halves can be compared
    refinement: type === "search" ? "rank:" + srankGroup() + "2" : params.refinement,   // "2": version 2
    surface: params.surface,
    filters: params.filters_used,
  });
}

/* Which search led to which product, for the product page to hand to the
   basket. Kept for the visit only, and only the last one - a shopper who
   searched "zoe", opened a Zoe, then came back and searched "jute" is on the
   jute trail now. */
function rememberSearch(p, term){
  try {
    sessionStorage.setItem("kk.searchctx", JSON.stringify({h: p.h, term: term, at: Date.now()}));
  } catch (e) { /* private windows: attribution is lost, nothing breaks */ }
}

/* One event per settled search. Firing on input would log "w", "wa", "was"
   ... and turn one search into sixteen, which wrecks the zero-results report:
   every real query passes through a dozen states that legitimately match
   nothing. */
let trackTimer = null, trackedLast = "";
function trackSearch(raw, surface){
  const term = (raw || "").trim().toLowerCase();
  clearTimeout(trackTimer);
  if (!term || term === trackedLast) return;
  trackTimer = setTimeout(() => {
    trackedLast = term;
    const res = search(term);
    // GA4's own recommended event name, and the one Smart Search already
    // reports under - so the before and after are the same measure
    track("view_search_results", {
      search_term: term,
      results_count: res.and.length,
      // which of the three quick filters were on, for the terms where people
      // immediately reach for one - that is a ranking problem, not a filter
      filters_used: [sel.washable && "washable", sel.pet && "pet",
                     sel.spill && "spill"].filter(Boolean).join("|"),
      // the panel's own state decides, not the caller: typing behind an open
      // panel also runs the results code, which reported last and mislabelled
      // every panel search as a results-page one
      surface: quickOpen ? "overlay" : (surface || "results"),
    });
  }, 900);
}

/* Provisional. Once this is in the theme, the cards get data-ga4-item and
   snippets/gtm-ecommerce.liquid emits select_item with the full ecommerce
   payload against list "search_results" - which is what joins a search to
   revenue. This stand-in only exists because the prototype has no theme
   behind it. */
function trackClick(p, position, where){
  rememberSearch(p, ($("q").value || "").trim().toLowerCase());
  track("search_click", {
    search_term: ($("q").value || "").trim().toLowerCase(),
    item_id: p.h,
    item_name: p.t,
    position: position,
    surface: where,           // overlay | results
  });
}

function run(raw){ last = search(raw); shown = PAGE; render(); writeUrl(); setMode(); trackSearch(raw, "results"); }

$("results").addEventListener("click", e => {
  const card = e.target.closest(".card");
  if (card){
    const grid = [...$("results").querySelectorAll(".card")];
    const i = grid.indexOf(card);
    const hit = applyFilters(last.and)[i];
    if (hit) trackClick(hit.d.p, i + 1, "results");
  }
  if (!e.target.closest("#more")) return;
  const first = shown;            // index of the first card about to appear
  shown += PAGE;
  render();
  // send the keyboard and screen reader to the new results rather than
  // leaving focus on a button that has just moved down the page
  const cards = document.querySelectorAll("#results .card");
  if (cards[first]) cards[first].focus();
});

/* ---------- quick search ---------- */
let quickOpen = false, activeRow = -1;
function closeQuick(){
  // whatever is in the box when the panel closes was a real search, typed on
  // purpose. Enter is not the only way a shopper finishes one.
  if (quickOpen) pushRecent($("q").value);
  quickOpen = false; activeRow = -1;
  $("quick").hidden = true; $("q").setAttribute("aria-expanded", "false");
}
/* The nine terms customers actually type, from 90 days of real search logs -
   runner alone is 5,224 searches. Guessing at "popular searches" is how you
   end up merchandising the words you wish people used. */
/* What customers type ALONGSIDE each word, from 90 days of search logs.
   "runner" -> stair, jute, washable, kitchen, hall. Demand, not arithmetic. */
const REFINE = {"*":["runner","jute","green","washable","round","pink","underlay","beige","blue","vintage","cream","terracotta","shaggy","distressed","grey","doormat","outdoor","stair","wool","cushion","kitchen","soft","brown","abstract","teal","checkerboard","hall","red","black","vogue","aztec","orange","navy","boho","traditional","bathroom","anti slip","kids","white","checker"],"abstract":["beige","distressed","green","blue","neutral"],"animal":["print"],"anti slip":["underlay"],"antislip":["underlay"],"art":["deco"],"aztec":["green"],"bathroom":["washable"],"beige":["distressed","abstract","vintage","runner","grace","fleur","zoe","shaggy","neutral","wool"],"best":["seller"],"big":["hill","house"],"black":["white","runner"],"blue":["runner","duck egg","distressed","navy","cream","soft","abstract","light","vintage","heritage"],"blush":["pink"],"board":["checker"],"boho":["soft","cream","flatwoven","washable","distressed","terracotta","green","faro"],"border":["jute"],"bordered":["wool"],"boucle":["jute"],"brown":["vintage","runner","washable"],"burnt":["orange"],"care":["instruction"],"century":["mid"],"checker":["board"],"checkerboard":["runner"],"cover":["cushion"],"cow":["print"],"cream":["soft","boho","shaggy","blue","runner","washable","green","beige","gold","vintage"],"cushion":["cover"],"cut":["measure"],"dark":["grey","green"],"deco":["art"],"dia":["duit"],"dining":["room"],"distressed":["beige","abstract","terracotta","traditional","green","blue","runner","flat","woven","neutral"],"doormat":["washable"],"double":["sided"],"duck egg":["blue"],"duit":["dia"],"extra":["large"],"faro":["flatwoven","washable","distressed","terracotta","green","boho"],"flat":["woven","weave","distressed"],"flatwoven":["washable","distressed","terracotta","green","boho","faro"],"fleur":["beige","renuu"],"floral":["green"],"friendly":["pet"],"gift":["voucher"],"gold":["cream"],"grace":["hatton","beige"],"green":["sage","runner","olive","pink","vintage","washable","distressed","abstract","cream","aztec"],"greige":["vintage"],"grey":["runner","shaggy","vintage","dark","beige","trellis","washable"],"hall":["runner"],"hallway":["runner"],"hard":["wearing"],"hatton":["grace","beige"],"heritage":["blue"],"herringbone":["runner"],"hill":["big","house"],"house":["big","hill"],"indoor":["outdoor"],"instruction":["care"],"irvine":["peter"],"isla":["vintage","beige"],"ivory":["vintage"],"juliette":["jute"],"jute":["runner","washable","round","boucle","border","sisal","rustic","juliette","natural"],"kids":["room"],"kitchen":["runner"],"large":["extra"],"leopard":["print"],"light":["blue"],"long":["runner"],"machine":["washable"],"measure":["cut"],"medallion":["pink","terracotta","traditional"],"mid":["century"],"muted":["green"],"natural":["runner","jute"],"navy":["blue"],"neutral":["beige","distressed","abstract"],"olive":["green"],"orange":["burnt","blue"],"outdoor":["indoor"],"pet":["friendly"],"peter":["irvine"],"pink":["green","runner","medallion","blush","vintage","shaggy","washable"],"plush":["soft"],"premium":["shaggy"],"print":["animal","zebra","leopard","cow"],"red":["runner"],"renuu":["fleur","beige"],"room":["dining","kids"],"round":["jute","washable"],"runner":["stair","washable","jute","hall","kitchen","green","hallway","blue","grey","beige"],"rustic":["jute"],"sabi":["wabi"],"sage":["green","runner"],"seller":["best"],"shaggy":["washable","grey","beige","cream","pink","green","runner","premium"],"sided":["double"],"sisal":["jute"],"slip":["runner"],"small":["runner"],"soft":["washable","cream","boho","blue","plush"],"stair":["runner"],"teal":["runner"],"terracotta":["distressed","runner","blue","medallion","flatwoven","washable","green","boho","faro"],"traditional":["distressed","beige","medallion"],"trellis":["grey"],"underlay":["anti slip","antislip"],"vintage":["beige","green","grey","runner","brown","pink","ivory","isla","blue","greige"],"vogue":["william"],"voucher":["gift"],"wabi":["sabi"],"warm":["white"],"washable":["soft","runner","jute","shaggy","green","machine","bathroom","cream","doormat","round"],"wearing":["hard"],"weave":["flat"],"white":["black","warm","runner"],"wide":["runner"],"william":["vogue"],"wool":["bordered","beige","runner"],"woven":["flat","distressed"],"zebra":["print","runner"],"zoe":["beige","runner"]};

/* Ranked on demand AND on what that demand lands on: searches from 90 days of
   logs, against units sold by the products the word actually returns.

   The old list was search volume alone and it showed. "isla" is 1,151
   searches and two products - a real search, a useless suggestion, because
   nobody who does not already know the name can act on it. "underlay" is an
   add-on nobody browses for. "zebra" is nine products.

   Washable was missing altogether: 2,082 searches, 382 rugs, 18,273 units.

   word          searches  products  units  units/product
   vintage          1,011        60  4,908       82
   terracotta         924        40  2,813       70
   boho               303        30  2,011       67
   green            2,868        83  4,393       53
   washable         2,082       382 18,273       48
   beige            1,201       194  9,498       49
   jute             5,137        85  3,234       38
   runner           7,622       297  5,109       17   (cheap, but the biggest
                                                       search on the site)
   isla             1,151         2    454      227   (dropped - a name)
   doormat            696        73    974       13   (dropped) */
// the first PHONE_POPULAR show on phones and tablets, all of them on desktop.
// John's list in Search Radar replaces this, in his order.
const POPULAR = ["washable", "runner", "jute", "beige", "vintage", "green", "terracotta", "boho"];

/* Underlay outsells every rug three to one - 9,623 units - because it goes in
   the basket ALONGSIDE a rug, not instead of one. Nobody browses a rug shop
   hoping to find underlay. So it is kept out of the merchandising slots and
   left entirely alone in search, where it earns 1,007 searches a quarter from
   people who came looking for it specifically. */
const bestSellers = n => DOCS.filter(d => !isAccessory(d.p))
  .sort((a, b) => (b.p.s || 0) - (a.p.s || 0)).slice(0, n).map(d => ({d}));

/* v27: on a phone the tile is 110px wide and two lines of title is all it
   gets, so six tiles read "Washable Beige Border Jute Sty..." and could not
   be told apart. The range name - the part after " - " - goes first there. */
function tileTitle(p, terms){
  const t = p.t || "", i = t.lastIndexOf(" - ");
  if (!isPhone() || i === -1) return highlight(t, terms);
  // "Juliette Navy" + "Navy Border Jute Rug": the colour once, not twice
  const name = t.slice(i + 3), inName = new Set(name.toLowerCase().split(/\s+/));
  const desc = t.slice(0, i).split(/\s+/).filter(w => !inName.has(w.toLowerCase())).join(" ");
  return '<b class="rn">' + esc(name) + '</b> ' + highlight(desc, terms);
}

function qProduct(r, terms, i){
  const p = r.d.p, im = imageFor(p);
  // Rating and badge belong here as much as on the results page - this is the
  // moment a shopper is deciding which of six to open, and 100% of the top 50
  // sellers have a real score to show.
  let rate = "";
  if (p.r){
    const filled = Math.round(p.r);
    let g = "";
    for (let i = 1; i <= 5; i++) g += (i <= filled ? STAR_FULL : STAR_EMPTY);
    rate = '<span class="rate"><span class="s">' + g + '</span>' +
           (p.rc ? '(' + p.rc.toLocaleString() + ')' : '') + '</span>';
  }
  const lbl = labelOf(p);
  const badge = lbl ? '<span class="qbadge">' + esc(lbl) + '</span>' : '';
  return '<a class="qprod" data-i="' + i + '" href="' + esc(linkFor(p)) +
    '">' +
    '<span class="im">' + (im ? '<img loading="eager" decoding="async" src="' + img600(im) + '" alt="">' : '') +
    badge + '</span>' +
    '<span class="t">' + tileTitle(p, terms) + '</span>' +
    '<span class="p"' + liveAttrs(p) + '>' + priceFor(p) + '</span>' + rate + '</a>';
}

/* What this shopper searched for before.

   Per-viewer and per-browser: it lives in localStorage, never reaches us, and
   is wrapped because private windows and blocked site data make every one of
   these calls throw. A missing list is a missing convenience, not a broken
   page. */
const RECENT_KEY = "kukoon.recent";
const RECENT_MAX = 4;
const RECENT_DAYS = 30;

/* Stored as [query, timestamp]. The old shape was a bare list of strings, so
   anything already in a browser is read and quietly upgraded rather than
   thrown away. */
function readRecentRows(){
  try {
    const v = JSON.parse(localStorage.getItem(RECENT_KEY) || "[]");
    if (!Array.isArray(v)) return [];
    const cut = Date.now() - RECENT_DAYS * 864e5;
    // a bare string is from a version before timestamps, so it is by
    // definition from an earlier visit - date it accordingly
    return v.map(x => Array.isArray(x) ? x : [x, cut + 1])
            .filter(x => typeof x[0] === "string" && x[1] > cut)
            .slice(0, RECENT_MAX);
  } catch (e) { return []; }            // private window, blocked site data
}
const SEEN_KEY = "kukoon.seen";
const VISIT_GAP = 30 * 60e3;

/* When this visit began. Reading it also stamps it, so the clock only runs
   between visits and not while somebody is browsing. */
function visitStart(){
  const now = Date.now();
  let start = now;
  try {
    const v = JSON.parse(localStorage.getItem(SEEN_KEY) || "null");
    if (v && now - v.seen < VISIT_GAP) start = v.start;
    localStorage.setItem(SEEN_KEY, JSON.stringify({start: start, seen: now}));
  } catch (e) { /* private window - every visit is the first one */ }
  return start;
}

/* Fixed at load, not read per call: a search made during this visit is
   stamped after the visit began, so it cannot come back at the shopper as a
   suggestion sixty seconds later. */
const VISIT_START = visitStart();
const readRecent = () => readRecentRows().filter(x => x[1] < VISIT_START).map(x => x[0]);

function pushRecent(q){
  q = (q || "").trim();
  if (q.length < 2) return;
  // only what worked. A search that returned nothing is not a shortcut back to
  // anything, and half a word on the way to a real search is not a search.
  if (!search(q).and.length) return;
  visitStart();                         // still here - keep the visit open
  const low = q.toLowerCase();
  try {
    const list = readRecentRows().filter(([x]) => {
      const o = x.toLowerCase();
      return o !== low && low.indexOf(o) !== 0;   // "gre" loses to "grey shaggy"
    });
    list.unshift([q, Date.now()]);
    localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, RECENT_MAX)));
  } catch (e) { /* nothing to remember it with */ }
}

function clearRecent(){
  try { localStorage.removeItem(RECENT_KEY); } catch (e) {}
}

const chips = (list, kind) => '<div class="qterms">' + list.map(t =>
  '<button class="qterm' + (kind === "recent" ? " recent" : "") + '" data-term="' +
  esc(t) + '">' + esc(t) + '</button>').join("") + '</div>';

/* Nothing typed yet. Three jobs at once: remind a returning shopper what they
   were looking at, show newcomers what other people search for, and give the
   empty right-hand column something that earns its place. */
function quickZero(){
  const best = bestSellers(6);
  const recent = readRecent();
  // chips, not a two-column list. As a grid it spread five short words across
  // the full width and left a hole in the middle of the panel, and it was the
  // only block in here that wasn't a row of chips.
  /* Washable used to vanish here. The row skipped any tile without a facet
     value, and Washable is a flag rather than a facet - so the single
     best-selling thing in the shop (382 rugs, 18,273 units, 2,082 searches a
     quarter) was the one category the overlay never offered. */
  // a phone list from Search Radar is shown whole; otherwise the desktop list,
  // with the ones past PHONE_TILES hidden on phones by CSS (.xtra)
  const phoneTiles = isPhone() && TILES_MOBILE.length;
  const shopBy = (phoneTiles ? TILES_MOBILE : TILES).map(([label, t], i) => {
    const n = tileMatch(t).length;
    const attr = t.url ? 'data-url="' + esc(t.url) + '"'
               : t.q ? 'data-term="' + esc(t.q) + '"'
               : t.flag ? 'data-flag="' + t.flag + '"'
                        : 'data-g="' + t.g + '" data-v="' + esc(t.v) + '"';
    return '<button class="qterm shop' + (!phoneTiles && i >= PHONE_TILES ? " xtra" : "") + '" ' + attr + '>' +
      esc(label) + (n ? '<span class="qn">' + n.toLocaleString() + '</span>' : '') + '</button>';
  }).join("");

  return '<div class="qzero">' +
      '<div class="qzleft">' +
        (recent.length
          ? '<div class="qhead">Recent searches' +
            '<button class="qclear" data-clear="1">Clear</button></div>' +
            // one row: more pushed the desktop panel into a scrollbar
            chips(recent.slice(0, 4), "recent")
          : '') +
        // Shop by sits above Popular searches: a category is somewhere to go,
        // a popular term is only a suggestion of what to type
        '<div class="qhead">Shop by</div><div class="qterms">' + shopBy + '</div>' +
        '<div class="qhead">Popular searches</div>' +
          '<div class="qterms">' + (isPhone() && POPULAR_MOBILE.length ? POPULAR_MOBILE : POPULAR).map((t, i) =>
            '<button class="qterm' + (!(isPhone() && POPULAR_MOBILE.length) && i >= PHONE_POPULAR ? ' xtra' : '') +
            '" data-term="' + esc(t) + '">' + esc(t) + '</button>').join("") + '</div>' +
      '</div>' +
    '</div>' +
    '<div class="qpad"><div class="qhead">People love</div></div>' +
    '<div class="qprods">' + best.map((r, i) => qProduct(r, [], i)).join("") + '</div>' +
    '';
}

/* Typing: a few products, the categories that match, and a way out to the
   full results page. The handful is the point - anyone who needs to compare
   twenty rugs wants the results page, not a modal. */
/* Words that are range NAMES: they appear after the " - " in titles
   ("... Jute Rug - Juliette Grey") and hardly ever in the description part. */
let RANGE_SET = null;
function RANGE_WORDS(){
  if (RANGE_SET) return RANGE_SET;
  const inName = new Map(), inDesc = new Map();
  for (const d of DOCS){
    const t = d.p.t || "", i = t.lastIndexOf(" - ");
    const bump = (m, w) => m.set(w, (m.get(w) || 0) + 1);
    if (i !== -1) tok(t.slice(i + 3)).forEach(w => bump(inName, stem(w)));
    tok(i === -1 ? t : t.slice(0, i)).forEach(w => bump(inDesc, stem(w)));
  }
  RANGE_SET = new Set([...inName].filter(([w, n]) => (inDesc.get(w) || 0) <= n * 0.2).map(([w]) => w));
  return RANGE_SET;
}

function quickResults(res){
  // a phone shows one row you swipe, so it can carry more than six
  // six on every screen: the phone swipe row (v25/26) was tried and dropped
  // v27: sold out stays on the results page (at the back) but not in the
  // six - the panel has room only for things someone can buy today
  // v27o (Jack, 2 Oct 2026): a phone keeps the 3 x 2 grid it liked, and
  // swipes sideways to a second six and then a "See all" tile - so a quick
  // look can go further without anyone thinking twelve is everything
  // two whole pages of six: eleven rugs and the See all tile, or up to
  // twelve rugs when that is all there is - never a page that stops half way
  const live = res.and.filter(r => !r.d.p.oos);
  // twelve rugs, two whole pages - no See all tile (Jack, 2 Oct: the button
  // under the row does that job)
  const N = isPhone() ? 12 : 6;
  const top = live.slice(0, N);
  if (!top.length) top.push(...res.and.slice(0, N));
  if (!top.length && res.near && res.near.length && !/\b(square|oval)\b/.test(norm($("q").value || ""))){
    const near = res.near.filter(r => !r.d.p.oos).slice(0, N);
    return '<div class="qpad"><div class="qhead">Nothing has every word</div>' +
      '<p style="margin:0 0 12px;font-size:13.5px;color:var(--muted)">The closest, without \u201c' + esc(res.gone) + '\u201d.</p></div>' +
      '<div class="qprods">' + near.map((r, i) => qProduct(r, res.terms, i)).join("") + '</div>';
  }
  if (!top.length){
    return '<div class="qpad"><div class="qhead">No matches</div>' +
      '<p style="margin:0 0 16px;font-size:13.5px;color:var(--muted)">' +
      'Nothing matches all of those words. Try one of these instead.</p>' +
      '<div class="qterms">' + POPULAR.slice(0, 6).map(t =>
        '<button class="qterm" data-term="' + esc(t) + '">' + esc(t) + '</button>').join("") +
      '</div></div>' +
      /* A dead end is the worst answer a search box can give. The panel had
         six chips and nothing else, so a typo or a range we don't sell left
         the shopper looking at white space. The same best sellers as the
         empty panel give them somewhere to go. */
      '<div class="qpad"><div class="qhead">People love</div></div>' +
      '<div class="qprods">' + bestSellers(6).map((r, i) => qProduct(r, [], i)).join("") + '</div>';
  }
  /* Refinements come from what people actually search next.

     The facet version could only offer "Wide Runner" for a query of "runner",
     because that was the value nearest to halving 297 results. The logs say
     shoppers want stair runners, jute runners, washable runners and kitchen
     runners - none of which is a facet, all of which convert.

     A suggestion is only shown if adding it to the query still returns
     something, so it can never lead to an empty page. */
  const typedSet = new Set(res.terms.flatMap(t => toks(t.word)));
  // candidates in priority order: first what people pair with THIS word, then
  // the site's overall demand list. The second layer is why a query the logs
  // have never seen - "rug", "circle", a colour nobody has combined with
  // anything - still gets pointed somewhere real instead of at Small/Medium/Large.
  const want = new Map();
  const offer = c => { if (!typedSet.has(c) && !want.has(c)) want.set(c, want.size); };
  for (const w of typedSet) for (const c of (REFINE[w] || [])) offer(c);
  for (const c of (REFINE["*"] || [])) offer(c);
  const refine = [];
  const base = res.terms.map(t => t.word).join(" ");
  for (const [word] of want){
    const n = search((base + " " + word).trim()).and.length;
    // it has to actually narrow. "hall" is the second most searched word after
    // runner, but it keeps 260 of 297 runners - popular and pointless here.
    // and it has to be worth a chip: two matches out of 190 is a product name
    // that wandered in, not a direction to send anybody
    // v27: at least 5 products or 5% - "sisal 2" was a chip - and never a
    // range name ("juliette"), which only means something to us
    const floor = Math.max(5, Math.round(res.and.length * 0.05));
    if (n >= floor && n <= res.and.length * 0.85 && !RANGE_WORDS().has(stem(word))) refine.push([word, n]);
    if (refine.length >= 6) break;
  }

  /* Only offer a filter that actually DIVIDES the results.

     Taking the two biggest values per group gave "Medium (22)" and "Living
     Room (22)" against 23 results - true, useless, and clicking it removed
     one rug. Nearly every Kukoon rug comes in nearly every size and suits
     nearly every room, so those facets almost never discriminate.

     So a value has to cover between a fifth and two thirds of the results,
     and the ones closest to halving the set are offered first. On a query
     where size genuinely splits, size still appears; on this one it does
     not, which is the correct answer rather than a special case. */
  const total = res.and.length;
  const typed = new Set(res.terms.flatMap(t => toks(t.word)));
  const scored = [];
  for (const g of GROUPS){
    const count = new Map();
    for (const r of res.and) for (const v of g.get(r.d.p))
      count.set(v, (count.get(v) || 0) + 1);
    for (const [v, n] of count){
      const share = n / total;
      if (n < 2 || share < 0.2 || share > 0.66) continue;
      // never offer back what was just typed - searching "grey" and being
      // shown a Grey shortcut, or "beige rug" and being shown Beige, is the
      // search repeating the question instead of answering it
      // drop it only if the WHOLE value was typed. "grey" after searching grey
      // is the question repeated; "Wide Runner" after searching runner is a
      // genuine narrowing and has to survive.
      const vw = toks(v);
      if (vw.length && vw.every(w => typed.has(w))) continue;
      // size is the weakest axis here - almost every rug comes in almost every
      // size - so it has to be clearly the best splitter to earn a slot
      const penalty = g.key === "size" ? 0.06 : 0;
      scored.push({k: g.key, v, n, gap: Math.abs(share - 0.45) + penalty});
    }
  }
  scored.sort((a, b) => a.gap - b.gap || b.n - a.n);
  const cats = scored.slice(0, 6);
  // demand first, facets only as a fallback for words the logs never saw
  const chipsHtml = refine.length
    ? refine.map(([w, n]) =>
        '<button class="qterm shop" data-add="' + esc(w) + '">' + esc(w) +
        '<span class="qn">' + n.toLocaleString() + '</span></button>').join("")
    : cats.map(c =>
        '<button class="qterm shop" data-g="' + c.k + '" data-v="' + esc(c.v) + '">' +
        esc(c.v) + '<span class="qn">' + c.n.toLocaleString() + '</span></button>').join("");
  const catHtml = chipsHtml
    ? '<div class="qpad"><div class="qhead">Narrow it down</div><div class="qterms">' +
      chipsHtml + '</div></div>'
    : "";
  /* Typing used to make the collection links vanish (Jack, 30 Sep 2026): the
     empty panel offers Runners, Doormats and the rest, and the moment someone
     typed "runner" the one link that answers it went away. A Shop by tile
     whose own words were typed comes back, as a link to its collection. */
  const typedStems = new Set(res.terms.flatMap(t => toks(t.word)));
  const collHtml = (isPhone() && TILES_MOBILE.length ? TILES_MOBILE : TILES).filter(([label, t]) => {
    if (!t.url) return false;
    const words = toks([label, t.v || "", t.flag || "", t.url.split("/").pop().replace(/-/g, " ")].join(" "))
      .filter(w => w !== stem("rug") && w !== stem("rugs"));
    return words.some(w => typedStems.has(w));
  }).slice(0, 2).map(([label, t]) =>
    '<a class="qterm shop qcoll" href="' + esc(path(t.url)) + '" data-coll="1">Shop all ' + esc(label.toLowerCase() + (/s$/i.test(label) ? "" : " rugs")) +
    ' <span aria-hidden="true">&rarr;</span></a>').join("");
  // the last tile of the phone row is the way to the rest - a swipe that
  // runs out of rugs lands on "See all", not on nothing
  const swipe = isPhone() && top.length > 6;
  const more = '';
  // the phone row fills column by column, so each page of six is re-ordered
  // to read across the rows like the grid did: 1 2 3 / 4 5 6
  // the See all tile is the last cell of page two: 7 8 9 / 10 11 [See all]
  const cells = top.map(r => qProduct(r, res.terms, res.and.indexOf(r)));
  if (more) cells.push(more);
  let order = cells;
  if (swipe) {
    order = [];
    for (let p = 0; p < cells.length; p += 6) {
      const pg = cells.slice(p, p + 6), a = pg.slice(0, 3), b = pg.slice(3);
      for (let i = 0; i < a.length; i++) { order.push(a[i]); if (b[i]) order.push(b[i]); }
    }
  }
  // no line of text above the row (it pushed See all off the screen): a
  // small arrow fades in on the right after a moment, and goes once swiped
  const prods = '<div class="qrow">' + '<div class="qprods' + (swipe ? ' qscroll' : '') + '">' + order.join("") + '</div>' +
    (swipe ? '<button class="qnext" data-qnext="1" aria-label="More results" tabindex="-1"><span aria-hidden="true">&rsaquo;</span></button>' : '') + '</div>';
  const colls = collHtml ? '<div class="qpad qcolls"><div class="qterms">' + collHtml + '</div></div>' : '';
  const qShown = norm($("q").value || "");
  const all = '<button class="all" data-all="1">See all ' + res.and.length.toLocaleString() +
    (qShown && qShown.length <= 22 ? ' “' + esc(qShown) + '”' : '') + ' results <span aria-hidden="true">&rarr;</span></button>';
  // a phone: See all straight under the products, where it is visible with
  // the keyboard up, then the ways to narrow (Jack, 30 Sep: a pinned button
  // covered "Narrow it down")
  // See all straight under the products, so it is on screen without
  // scrolling; the ways to narrow come after it (Jack, 2 Oct 2026)
  return prods + all + colls + catHtml;
}

let QUIET = false;
function renderQuick(raw){
  const box = $("quick");
  // a phone shows this as a full-height sheet, and a sheet needs a visible way
  // out - tapping outside is not discoverable when the panel fills the screen
  const close = '<button class="qclose" data-qclose="1">Close</button>';
  box.innerHTML = close +
    (norm(raw).length < 1 ? quickZero() : quickResults(search(raw)));
  // the panel is where most searches happen, and most end in a click rather
  // than Enter - so it reports its own, settled the same way as the page
  // QUIET: a panel put back on "back" is the same search, not a new one
  if (norm(raw).length >= 1 && !QUIET) trackSearch(raw, "overlay");
  livePrices();
  box.hidden = false; quickOpen = true; activeRow = -1;
  $("q").setAttribute("aria-expanded", "true");
}

function moveActive(delta){
  const rows = [...$("quick").querySelectorAll(".qprod")];
  if (!rows.length) return;
  rows.forEach(r => r.removeAttribute("data-active"));
  activeRow = (activeRow + delta + rows.length) % rows.length;
  rows[activeRow].setAttribute("data-active", "true");
  rows[activeRow].scrollIntoView({block:"nearest"});
}

/* While the overlay is open it is the ONLY thing responding to typing. The
   page underneath used to re-run on every keystroke as well, so a shopper
   typing "bei" saw six suggestions floating over a grid of the same rugs -
   two answers to one question, competing for the same glance.

   The page now waits to be asked: Enter, See all, a category, or a popular
   term. Which is also how it behaves on kukoon.com today. */
function commit(raw){
  if (!cfg.isSearchPage){
    pushRecent(raw);
    window.location.href = (cfg.searchUrl || "/search") + "?q=" + encodeURIComponent(raw);
    return;
  }
  $("q").value = raw;
  pushRecent(raw);
  run(raw);
  closeQuick();
  window.scrollTo({top: 0});
}

/* The page follows the typing again.

   It was held back so the overlay and the grid were not answering at once,
   but that made an emptied search box leave the previous results sitting
   underneath - the page looked stuck. Live is the right call; it is debounced
   so the grid is not rebuilt on every keystroke. */
let typeTimer = null;
$("q").addEventListener("input", e => {
  const v = e.target.value;
  renderQuick(v);
  clearTimeout(typeTimer);
  // no wait at all when the box is cleared - going back to browse should feel
  // immediate, not delayed by a timer meant for typing
  typeTimer = setTimeout(() => { run(v); }, v.trim() ? 160 : 0);
});
$("q").addEventListener("focus", e => renderQuick(e.target.value));
$("q").addEventListener("keydown", e => {
  if (e.key === "Escape"){ closeQuick(); return; }
  // Enter runs the search whether the overlay happens to be open or not.
  // It used to sit behind the quickOpen guard, so pressing Enter a second
  // time - or on a box that already had text in it - did nothing at all.
  if (e.key === "Enter" && !quickOpen){ e.preventDefault(); commit(e.target.value); return; }
  if (!quickOpen) return;
  if (e.key === "ArrowDown"){ e.preventDefault(); moveActive(1); }
  else if (e.key === "ArrowUp"){ e.preventDefault(); moveActive(-1); }
  else if (e.key === "Enter"){
    const rows = [...$("quick").querySelectorAll(".qprod")];
    // Enter on a highlighted row opens that product, matching the click.
    // Enter with nothing highlighted just runs the search, as before.
    if (activeRow >= 0 && rows[activeRow]){
      e.preventDefault();
      rows[activeRow].click();
      closeQuick();
    } else {
      e.preventDefault();
      commit(e.target.value);
    }
  }
});
/* Which shortcut was tapped (21 Oct 2026, Jack): recent searches, popular
   searches, Shop by tiles and suggestion chips all used to arrive as ordinary
   searches (or not at all), so nobody could say whether they get used. One
   "tap:<kind>:<value>" refine each; the dashboard keeps them out of its filter
   and "refined" counts. Collection links and add-a-word chips log themselves. */
function logTap(el){
  if (!el || el.dataset.add != null || el.dataset.coll != null) return;
  const v = el.dataset.term || (el.dataset.url || "").split("/").pop() || el.dataset.flag ||
            (el.dataset.g ? el.dataset.g + "=" + (el.dataset.v || "") : "");
  if (!v) return;
  const kind = el.classList.contains("recent") ? "recent"
             : el.classList.contains("shop") ? (el.closest(".qzleft") ? "tile" : "chip")
             : "popular";
  track("search_refine", {search_term: ($("q").value || "").trim().toLowerCase() || String(v).toLowerCase(),
    refinement: "tap:" + kind + ":" + String(v).toLowerCase(), surface: "overlay"});
}
$("quick").addEventListener("click", e => {
  logTap(e.target.closest(".qterm, .qcat"));
  if (e.target.closest("[data-clear]")){
    clearRecent();
    renderQuick($("q").value);
    return;
  }
  if (e.target.closest("[data-qclose]")){ closeQuick(); return; }
  // a collection link is a real link: let it go, just note it and close
  const coll = e.target.closest("[data-coll]");
  if (coll){
    track("search_refine", {search_term: ($("q").value || "").trim().toLowerCase(),
      refinement: "collection:" + (coll.getAttribute("href") || "").split("/").pop(), surface: "overlay"});
    pushRecent($("q").value);
    closeQuick();
    return;
  }
  const term = e.target.closest("[data-term]");
  if (term){
    clearFilters();
    commit(term.dataset.term);
    return;
  }
  const add = e.target.closest("[data-add]");
  if (add){
    track("search_refine", {
      search_term: ($("q").value || "").trim().toLowerCase(),
      refinement: add.dataset.add,
    });
    commit(($("q").value + " " + add.dataset.add).replace(/\s+/g, " ").trim());
    return;
  }
  const cat = e.target.closest(".qcat, .qterm.shop");
  if (cat && cat.dataset.url){
    // a Shop by tile is a link to its collection, in this shopper's market
    closeQuick();
    window.location.href = path(cat.dataset.url);
    return;
  }
  if (cat){
    // a category shortcut goes to the results page WITH that filter applied,
    // which is what a shopper picking "Runner" from the overlay means
    if (!cfg.isSearchPage){
      const u = new URLSearchParams();
      if (cat.dataset.flag) u.set(cat.dataset.flag, "1");
      else u.set(cat.dataset.g, cat.dataset.v);
      window.location.href = (cfg.searchUrl || "/search") + "?" + u.toString();
      return;
    }
    if (cat.dataset.flag) sel[cat.dataset.flag] = true;
    else sel[cat.dataset.g].add(cat.dataset.v);
    // picked from the home screen, where the results view is hidden: without
    // this the filter applied and rendered somewhere nobody could see it, and
    // Shop by looked like a dead button
    $("q").value = "";
    last = search("");
    shown = PAGE;
    render();
    writeUrl();
    setMode();
    closeQuick();
    window.scrollTo({top: 0});
    return;
  }
  if (e.target.closest("[data-all]")){ commit($("q").value); return; }
  const nx = e.target.closest("[data-qnext]");
  // (the arrow's swipe watcher now starts with the page: snippets/kukoon-search-theme.liquid)

  if (nx){
    const g = nx.parentElement.querySelector(".qprods");
    if (g){
      const from = g.scrollLeft;
      g.scrollBy({left: g.clientWidth, behavior: "smooth"});
      // where smooth scrolling is off or paused, jump instead
      setTimeout(() => { if (g.scrollLeft === from) g.scrollLeft = from + g.clientWidth; }, 450);
    }
    return;
  }
  const qp = e.target.closest(".qprod");
  if (qp){
    // opening a product IS the end of that search, so remember it - most
    // shoppers never press Enter, they click the thing they wanted
    pushRecent($("q").value);
    const i = +qp.dataset.i;
    const hit = (last && last.and ? last.and[i] : null) || (search($("q").value).and || [])[i];
    if (hit) trackClick(hit.d.p, i + 1, "overlay");
    closeQuick();
  }
});
document.addEventListener("click", e => {
  // Clearing recent searches re-renders the panel, which detaches the button
  // that was clicked before this handler runs - closest() then finds nothing
  // and the overlay closed itself. A detached target was inside the panel.
  if (!e.target.isConnected) return;
  if (!e.target.closest(".searchwrap")) closeQuick();
});

document.querySelectorAll(".tryb[data-q]").forEach(b => b.addEventListener("click", () => {
  $("q").value = b.dataset.q;
  clearFilters();
  run(b.dataset.q); closeQuick();
}));

/* filters + sort */
$("qflags").addEventListener("change", e => {
  if (e.target.dataset.flag){
    if (e.target.checked) trackFilter("flag:" + e.target.dataset.flag);
    sel[e.target.dataset.flag] = e.target.checked; shown = PAGE; render(); writeUrl();
  }
});

// a group opened by the shopper (not by a redraw): "expand:<group>"
$("side").addEventListener("click", e => {
  const s = e.target.closest && e.target.closest("summary");
  const d = s && s.parentElement;
  if (!d || !d.dataset || !d.dataset.key) return;
  setTimeout(() => { if (d.open) trackFilter("expand:" + d.dataset.key); }, 0);
});
$("side").addEventListener("toggle", e => {
  const d = e.target;
  if (!d || !d.dataset || !d.dataset.key) return;
  if (d.open) OPEN_GROUPS.add(d.dataset.key); else OPEN_GROUPS.delete(d.dataset.key);
}, true);
/* Every filter ticked is logged (30 Sep 2026): which groups people use is what
   decides their order, and only 2% of searches were being refined at all. */
function trackFilter(what){
  track("search_refine", {
    search_term: ($("q").value || "").trim().toLowerCase(),
    refinement: what,
    surface: drawerWidth() ? "filters-phone" : "filters",
  });
}
$("side").addEventListener("change", e => {
  const t0 = e.target;
  if (t0.checked && t0.dataset.g) trackFilter("filter:" + t0.dataset.g + "=" + t0.value);
  const t = e.target;
  if (t.dataset.g){
    const set = sel[t.dataset.g];
    t.checked ? set.add(t.value) : set.delete(t.value);
  } else if (t.dataset.flag){
    sel[t.dataset.flag] = t.checked;
  } else return;
  shown = PAGE;
  render();
  writeUrl();
});
let drawerY = 0;
function drawer(open){
  // iPhone Safari ignores overflow:hidden on the body, so the results
  // scrolled behind the Filters sheet: pin the body while it is open
  const was = document.body.classList.contains("drawer"), b = document.body.style;
  if (open && !was && window.matchMedia("(max-width:860px)").matches){
    drawerY = window.scrollY || 0;
    b.position = "fixed"; b.top = (-drawerY) + "px"; b.left = "0"; b.right = "0"; b.width = "100%";
  } else if (!open && was && b.position === "fixed"){
    b.position = b.top = b.left = b.right = b.width = "";
    window.scrollTo(0, drawerY);
  }
  document.body.classList.toggle("drawer", open);
  $("filterbtn").setAttribute("aria-expanded", open ? "true" : "false");
}
function tileClick(e){
  const b = e.target.closest("[data-tile]");
  if (!b) return;
  const t = TILES[+b.dataset.tile][1];
  clearFilters();
  if (t.q){ commit(t.q); return; }
  if (!search($("q").value).and.length){ $("q").value = ""; last = search(""); }
  if (t.flag) sel[t.flag] = true; else sel[t.g].add(t.v);
  shown = PAGE;
  render(); writeUrl(); setMode();
  window.scrollTo({top: 0});
}
$("tiles").addEventListener("click", tileClick);
// the same tiles appear on the dead end, which lives in a different container
$("results").addEventListener("click", tileClick);

$("home").addEventListener("click", e => {
  const cta = e.target.closest(".herocta");
  if (cta){ clearFilters(); commit(cta.dataset.term); }
});

/* the logo-resets-the-search handler was here; the theme logo is a link home */

$("filterbtn").addEventListener("click", () => { drawer(true); trackFilter("open"); });
$("drawerback").addEventListener("click", () => drawer(false));
document.addEventListener("keydown", e => {
  if (e.key === "Escape" && document.body.classList.contains("drawer")){
    drawer(false); $("filterbtn").focus();
  }
});

$("side").addEventListener("click", e => {
  if (e.target.id === "drawerdone" || e.target.closest("#drawerclose")){ drawer(false); return; }
  if (e.target.id !== "clearall" && e.target.id !== "clearall2") return;
  clearFilters();
  shown = PAGE;
  render();
  writeUrl();
});
$("sortmount").addEventListener("change", e => {
  if (e.target.id !== "fSort") return;
  sortMode = e.target.value;
  shown = PAGE;
  render();
  writeUrl();
});

/* no-results suggestion chips */
$("results").addEventListener("click", e => {
  const b = e.target.closest("[data-try], [data-flag], [data-g]");
  if (!b) return;
  clearFilters();
  if (b.dataset.try !== undefined){
    $("q").value = b.dataset.try;
    run(b.dataset.try);
  } else {
    // a category picked from a dead end clears the failed query - keeping it
    // would filter that category straight back down to nothing
    $("q").value = "";
    last = search("");
    if (b.dataset.flag) sel[b.dataset.flag] = true;
    else sel[b.dataset.g].add(b.dataset.v);
    shown = PAGE; render(); writeUrl();
  }
  window.scrollTo({top: 0});
});

const REDUCED = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
let demoTimer = null;
$("demo").addEventListener("click", () => {
  const target = "grey shaggy rug";
  clearTimeout(demoTimer);
  clearFilters();
  if (REDUCED){ $("q").value = target; run(target); return; }
  $("q").value = ""; run("");
  let i = 0;
  const step = () => {
    i++;
    const slice = target.slice(0, i);
    $("q").value = slice; run(slice);
    if (i < target.length) demoTimer = setTimeout(step, target[i] === " " ? 320 : 85);
  };
  demoTimer = setTimeout(step, 180);
});

/* opens on the browse state, exactly as a shopper first meets it */
// restore whatever the address bar asks for, then draw
applySettings(typeof KUKOON_SETTINGS !== "undefined" ? KUKOON_SETTINGS : null);

const initial = cfg.isSearchPage ? readUrl() : "";
// Off /search the index now arrives only once the box is touched, so the
// shopper may already have typed: keep it, and boot() replays it (12 Oct 2026)
if (cfg.isSearchPage || !$("q").value) $("q").value = initial;
if (cfg.isSearchPage){
  renderHome();
  run(initial);
  /* Back from a product put you at the top of the results (Jack, 12 Oct
     2026). The results are drawn after the index loads, so the browser's own
     scroll restore had nothing to scroll to yet, and "Show more" pages were
     gone. Where you were and how many results were showing are kept for this
     address, and put back once the results are on the page. */
  try { history.scrollRestoration = "manual"; } catch (e) {}
  const POS = "kk.searchpos";
  const keepPos = () => {
    try { sessionStorage.setItem(POS, JSON.stringify({u: location.pathname + location.search, y: window.scrollY, n: shown, at: Date.now()})); } catch (e) {}
  };
  window.addEventListener("pagehide", keepPos);
  document.addEventListener("click", e => { if (e.target.closest && e.target.closest("#results a")) keepPos(); }, true);
  const putBack = () => {
    try {
      const p = JSON.parse(sessionStorage.getItem(POS) || "null");
      if (!p || p.u !== location.pathname + location.search || Date.now() - p.at > 30 * 60 * 1000) return;
      if (p.n > shown){ shown = p.n; render(); }
      const go = () => window.scrollTo(0, p.y);
      go(); requestAnimationFrame(go); setTimeout(go, 350);   // again once images have taken their space
    } catch (e) {}
  };
  const nav = (performance.getEntriesByType && performance.getEntriesByType("navigation")[0]) || {};
  if (nav.type === "back_forward") putBack();
  // iPhone Safari usually brings the page back frozen (the back-forward
  // cache) rather than loading it again, so nothing above runs - and with
  // scroll restoration off it showed the top. Put it back then too.
  window.addEventListener("pageshow", e => { if (e.persisted) putBack(); });
} else {
  // enough to answer the panel while the shopper types, and nothing else
  last = search("");
}

(function(){
  function restore(){
    if (cfg.isSearchPage) return;
    let term = "";
    try {
      const c = JSON.parse(sessionStorage.getItem("kk.searchctx") || "null");
      if (c && c.term && Date.now() - (c.at || 0) < 30 * 60 * 1000) term = c.term;
    } catch (e) {}
    if (!term || !norm(term)) return;
    $("q").value = term;
    const slot = document.querySelector("[data-kuk-search-slot]");
    if (slot) slot.classList.add("kuk-open");
    QUIET = true;
    try { renderQuick(term); } finally { QUIET = false; }
  }
  const nav = (performance.getEntriesByType && performance.getEntriesByType("navigation")[0]) || {};
  if (nav.type === "back_forward") restore();
  window.addEventListener("pageshow", e => { if (e.persisted) restore(); });
})();

  }
})();
